(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
// ── Cart upsells ──
//
// What this fixes, measured against 1,011 paid orders (Aug 2025 - Aug 2026)
// and a live probe of 20 products / 160 recommendation slots on 2026-08-22:
//
//   * `complementary` returned ZERO results on every product tested. Nobody has
//     curated it in Search & Discovery, so it was always falling through.
//   * `related` put the WRONG RACK SIZE in 23% of slots, and led with a
//     wrong-size product on 40% of products. Real customers cross the 10"/19"
//     line in 1.2% of co-purchases. The engine was spending a quarter of the
//     row on the one thing that essentially never happens.
//   * 10% of slots were the SAME DEVICE in the other rack size — a substitute,
//     not a complement, and an outright wrong purchase if acted on. Every one
//     of those was cross-size, so the size filter alone removes all of them.
//
// So we keep Shopify's relevance ranking and apply our own hard filter on top.
// The candidates arrive as rendered HTML from sections/cart-upsell.liquid, each
// card stamped with data-rack / data-affinity / data-accessory, because the
// JSON endpoint does not return tags.
(function () {
  // The bundled script can be evaluated more than once; without this the
  // recommendation endpoint was hit twice per page load.
  if (window.__rmUpsellRan) return;
  window.__rmUpsellRan = true;

  var box = document.getElementById('cart-upsell');
  var row = document.getElementById('cart-upsell-row');
  if (!box || !row) return;
  // A curated collection already filled the row server-side. It has been
  // size-filtered in Liquid, so leave it alone.
  if (row.querySelector('.rm-cart__upsell-card')) { box.hidden = false; settle(); return; }

  // Set once the row has reached its final state, whether that is populated or
  // deliberately empty. Without it the only way to tell "still fetching" from
  // "nothing to show" is a timeout, which makes tests slow and flaky.
  function settle() { window.__rmUpsellSettled = true; }

  var pid = box.dataset.productId;
  var limit = parseInt(box.dataset.limit, 10) || 3;
  var intent = box.dataset.intent || 'related';
  if (!pid) { settle(); return; }

  var cart = window.__rmCart || { rack: '', affinity: '', lines: 0, hasPatchPanel: false };
  var inCart = {};
  (window.__rmCartIds || []).forEach(function (id) { inCart[id] = 1; });

  var cartTags = {};
  String(cart.affinity || '').split(/\s+/).forEach(function (t) { if (t) cartTags[t] = 1; });

  function score(card) {
    // Patch panels first, but only once the cart looks like a rack build.
    // Attach rate climbs 0.1% -> 5.7% -> 16.7% -> 35.7% as a basket goes from
    // one to four distinct products, and 13 of 13 real patch-panel purchases
    // matched the rest of the basket's rack size. Below two lines it is noise,
    // and pushing it there would burn the best slot on the wrong customer.
    if (card.dataset.accessory === 'patch-panel') {
      return (cart.lines >= 2 && !cart.hasPatchPanel) ? 1000 : -1000;
    }
    // Then brand/device overlap: 34 of 119 multi-product baskets repeat a
    // brand against 12.7 expected by chance. This only ever REORDERS, so a
    // thin overlap can never empty the row.
    var hits = 0;
    String(card.dataset.affinity || '').split(/\s+/).forEach(function (t) {
      if (t && cartTags[t]) hits++;
    });
    return hits;
  }

  // The size-matched patch panel, rendered server-side and held back. It is
  // injected rather than filtered out of Shopify's list because the engine
  // often does not return it at all.
  function injected() {
    var host = document.getElementById('cart-upsell-inject');
    if (!host) return [];
    if (cart.lines < 2 || cart.hasPatchPanel) return [];
    return [].slice.call(host.querySelectorAll('.rm-cart__upsell-card'));
  }

  function render(html) {
    var parsed = document.createElement('div');
    parsed.innerHTML = html;

    var cards = injected().concat([].slice.call(parsed.querySelectorAll('.rm-cart__upsell-card')));

    var seen = {};
    var kept = cards.filter(function (card) {
      // The engine sometimes returns the same panel we injected.
      if (seen[card.dataset.pid]) return false;
      seen[card.dataset.pid] = 1;
      if (inCart[card.dataset.pid]) return false;
      var rack = card.dataset.rack || '';
      // "" is rack-neutral (the power-supply-shelf blanks) and always allowed.
      // Anything that resolves to the other rack is dropped outright.
      if (rack && cart.rack && rack !== cart.rack) return false;
      if (card.dataset.accessory === 'patch-panel' && (cart.lines < 2 || cart.hasPatchPanel)) return false;
      return true;
    });

    // Stable sort: equal scores keep Shopify's own relevance order.
    kept = kept
      .map(function (card, i) { return { card: card, s: score(card), i: i }; })
      .sort(function (a, b) { return b.s - a.s || a.i - b.i; })
      .slice(0, limit)
      .map(function (x, i) {
        // Attribution (upsell proposal #1): which slot the card landed in and
        // why. The Add handler reads these and sends them as a hidden
        // _upsell line property.
        x.card.dataset.slot = String(i + 1);
        x.card.dataset.source = x.card.dataset.accessory === 'patch-panel' ? 'panel'
          : (x.s > 0 ? 'affinity' : 'engine');
        return x.card;
      });

    if (!kept.length) return;
    row.innerHTML = '';
    kept.forEach(function (card) { row.appendChild(card); });
    box.hidden = false;
  }

  function ask(which) {
    // Section rendering, not products.json — the JSON payload carries no tags,
    // and rack size cannot be judged without them.
    return fetch('/recommendations/products?section_id=cart-upsell'
                 + '&product_id=' + encodeURIComponent(pid)
                 + '&limit=10&intent=' + which)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; });
  }

  function hasCards(html) { return html && html.indexOf('rm-cart__upsell-card') !== -1; }

  ask(intent).then(function (html) {
    // "complementary" is curated in admin and is currently empty on every
    // product; fall back rather than showing nothing.
    if (!hasCards(html) && intent === 'complementary') return ask('related');
    return html;
  }).then(function (html) {
    // Render even with no recommendations: the injected panel may stand alone.
    if (hasCards(html) || injected().length) render(html || '');
  }).catch(function () {
    // An empty suggestion strip is better than a broken one.
  }).then(settle);
})();

// ── Cart AJAX ───────────────────────────────────────────────────────────────
//
// The IIFE is load-bearing. `if (!cartForm) return;` below is a top-level
// return, which a browser rejects outright as "Illegal return statement" in a
// classic script. It has only ever worked because Shopify wraps each section's
// javascript block in a function of its own when it bundles the theme —
// undocumented behaviour no file should rest on. The wrapper was here
// originally (b04b5a3) and was dropped by c8667fc along with its `})();`.
// (Spelling that tag out here trips theme-check's Liquid-in-JS rule, hence the
// wording.)
(function () {
  var cartForm = document.getElementById('cart-form');
  if (!cartForm) return;

  // ── Money ─────────────────────────────────────────────────────────────────
  //
  // Was: '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''), which had two
  // bugs. It stripped the cents off a round amount, so a line the server
  // rendered "$60.00" became "$60" the moment the stepper was touched; and it
  // hardcoded "$" although this store sells into 18 presentment currencies.
  //
  // Rather than reimplement Shopify's money_format placeholders, this reads the
  // shape off window.__rmMoney.sample — Liquid's own rendering of a known
  // amount (111222333 cents), emitted at the top of this section. Whatever
  // symbol, grouping and decimal count the storefront is using for the currency
  // this buyer is actually browsing in is what comes back. The derivation is
  // checked against that same sample before it is trusted, so a format it
  // cannot reproduce falls back rather than printing something wrong.
  var formatMoney = (function () {
    var plain = function (cents) { return '$' + (Number(cents) / 100).toFixed(2); };
    var raw = (window.__rmMoney || {}).sample;
    if (!raw) return plain;

    // A money format may carry HTML entities (&pound;, &#36;). The page shows
    // them decoded, so decode here too or the strings will not match.
    var decoder = document.createElement('div');
    decoder.innerHTML = String(raw);
    var sample = (decoder.textContent || '').trim();

    var core = sample.match(/[0-9][0-9.,'\u00a0\u202f\u2009 ]*[0-9]/);
    if (!core) return plain;

    var prefix = sample.slice(0, core.index);
    var suffix = sample.slice(core.index + core[0].length);
    var seps = core[0].match(/[^0-9]/g) || [];
    var parts = core[0].split(/[^0-9]/);
    // 111222333 renders as either "1,112,223.33" (two decimals) or "1,112,223"
    // (none), so the trailing group is 2 digits or 3. There is no third case.
    var decimals = seps.length && parts[parts.length - 1].length === 2 ? 2 : 0;
    var decimalSep = decimals ? seps[seps.length - 1] : '';
    var groupSeps = decimals ? seps.slice(0, -1) : seps;
    var groupSep = groupSeps.length ? groupSeps[0] : '';

    var fn = function (cents) {
      var n = Number(cents) || 0;
      var sign = n < 0 ? '-' : '';
      var fixed = (Math.abs(n) / 100).toFixed(decimals);
      var whole = fixed;
      var frac = '';
      if (decimals) {
        var dot = fixed.indexOf('.');
        whole = fixed.slice(0, dot);
        frac = fixed.slice(dot + 1);
      }
      if (groupSep) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, groupSep);
      return sign + prefix + whole + (decimals ? decimalSep + frac : '') + suffix;
    };

    return fn(111222333) === sample ? fn : plain;
  })();

  // Exposed on purpose, the same way __rmUpsellSettled is: it is the only way to
  // assert the formatter against known amounts (a round dollar, a value that
  // needs a thousands separator) without a fixture priced to hit them, and the
  // catalogue has no whole-dollar price to hit one with.
  window.__rmFormatMoney = formatMoney;

  // The server writes &minus; (U+2212) in front of the savings figures, so the
  // client has to as well or a re-render silently changes the character.
  var MINUS = '\u2212';

  function el(id) { return document.getElementById(id); }
  function setText(id, text) { var n = el(id); if (n) n.textContent = text; }
  function setHidden(id, hidden) { var n = el(id); if (n) n.hidden = hidden; }
  function compareAtOf(key) {
    var row = el('cart-item-' + key.replace(':', '-'));
    var v = row ? parseInt(row.getAttribute('data-compare-at'), 10) : 0;
    return v > 0 ? v : 0;
  }

  function updateHeaderCount(count) {
    // The refresh header renders the count as "(n)" in [data-cart-count]; the
    // old .site-nav__cart-count no longer exists, so this silently stopped
    // updating when the header was rebuilt.
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = '(' + count + ')';
    });
  }

  // ── Summary ───────────────────────────────────────────────────────────────
  //
  // Mirrors the Liquid at the top of this section line for line. It has to be
  // duplicated because /cart/change.js does not return compare_at_price — the
  // per-line figure comes off data-compare-at, which the template stamps.
  //
  // Every number below is derived from ONE cart response, so the column cannot
  // contradict itself. Before this, only the Total row was updated and the
  // Subtotal and Sale saving rows kept their page-load values, leaving carts
  // reading "Subtotal $119.98 − Saving $20.00 = Total $89.99".
  function summarise(cartData) {
    var full = 0;
    cartData.items.forEach(function (item) {
      var compareAt = compareAtOf(item.key);
      if (compareAt && compareAt > item.original_price) {
        full += compareAt * item.quantity;
      } else {
        full += item.original_line_price;
      }
    });
    return {
      full: full,
      // Both differences are taken against original_total_price, so an applied
      // discount code lands in the code row instead of inflating the sale
      // saving. full - saving - code === total, always.
      saving: full - cartData.original_total_price,
      code: cartData.original_total_price - cartData.total_price,
      total: cartData.total_price,
      count: cartData.item_count
    };
  }

  function renderCart(cartData) {
    cartData.items.forEach(function (item) {
      var slug = item.key.replace(':', '-');
      setText('line-price-' + slug, formatMoney(item.final_line_price));
      var compareAt = compareAtOf(item.key);
      if (compareAt && compareAt > item.original_price) {
        setText('line-was-' + slug, formatMoney(compareAt * item.quantity));
      }
    });

    var s = summarise(cartData);

    setText('cart-item-count', '(' + s.count + ' item' + (s.count === 1 ? '' : 's') + ')');
    setText('cart-full-subtotal', formatMoney(s.full));
    setText('cart-savings', MINUS + formatMoney(s.saving));
    setHidden('cart-savings-row', s.saving <= 0);
    setText('cart-code-amount', MINUS + formatMoney(s.code));
    setHidden('cart-code-row', s.code <= 0);
    setText('cart-subtotal', formatMoney(s.total));
    updateShipping(cartData);

    // The banner repeats the saving, so it goes stale the same way.
    setText('cart-banner-savings', formatMoney(s.saving));
    setHidden('cart-banner-saving-text', s.saving <= 0);
    if (s.saving <= 0 && !el('cart-banner-free')) setHidden('cart-banner', true);
  }

  // US shipping row: re-band on the new cart weight after every change, the
  // same bands the server used. A free-shipping banner wins; no bands (non-US)
  // leaves the server's "Calculated at checkout" alone.
  function bandPrice(grams, bands) {
    if (!(grams > 0) || !bands) return '';
    var oz = grams / 28.3495, list = bands.split(',');
    for (var i = 0; i < list.length; i++) {
      var parts = list[i].trim().split(':');
      if (parts.length !== 2) continue;
      if (parts[0] === '*' || oz <= parseFloat(parts[0])) return parts[1];
    }
    return '';
  }
  function updateShipping(cartData) {
    var row = el('cart-ship-row'), val = el('cart-ship-value');
    if (!row || !val || !row.dataset.bands || el('cart-banner-free')) return;
    var price = bandPrice(cartData.total_weight, row.dataset.bands);
    if (!price) return;
    val.textContent = '$' + price;
  }
  function addBusinessDays(from, n) {
    var d = new Date(from.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) n--;
    }
    return d;
  }
  (function fillArrival() {
    var row = el('cart-arrival-row'), dates = el('cart-arrival-dates');
    if (!row || !dates) return;
    var ds = row.dataset;
    var lo = (parseInt(ds.shipMin, 10) || 0) + (parseInt(ds.transitMin, 10) || 0);
    var hi = (parseInt(ds.shipMax, 10) || 0) + (parseInt(ds.transitMax, 10) || 0);
    if (!(lo > 0) || hi < lo) return;
    var a = addBusinessDays(new Date(), lo), b = addBusinessDays(new Date(), hi);
    var fmt = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    dates.textContent = fmt(a) + ' to ' + (a.getMonth() === b.getMonth() ? b.getDate() : fmt(b));
    row.hidden = false;
  })();

  function removeItemUI(key) {
    var row = el('cart-item-' + key.replace(':', '-'));
    if (row) {
      row.classList.add('is-removing');
      setTimeout(function () {
        row.remove();
        // If no items left, reload to show empty state
        if (!document.querySelector('.cart-item')) {
          window.location.reload();
        }
      }, 220);
    }
  }

  function cartChange(key, quantity) {
    var row = el('cart-item-' + key.replace(':', '-'));
    if (row) row.classList.add('cart-item-updating');

    var checkoutBtn = el('cart-checkout-btn');
    if (checkoutBtn) checkoutBtn.disabled = true;

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (row) row.classList.remove('cart-item-updating');
        if (checkoutBtn) checkoutBtn.disabled = false;

        if (quantity === 0) {
          removeItemUI(key);
        } else {
          // Keep input in sync
          var input = document.querySelector('.cart-qty__input[data-key="' + key + '"]');
          if (input) input.value = quantity;
        }

        updateHeaderCount(cart.item_count);
        renderCart(cart);
        tradePricing(cart);
        insertPricing(cart);
      })
      .catch(function () {
        if (row) row.classList.remove('cart-item-updating');
        if (checkoutBtn) checkoutBtn.disabled = false;
      });
  }

  // +/- buttons
  document.querySelectorAll('.cart-qty').forEach(function (stepperEl) {
    var input = stepperEl.querySelector('.cart-qty__input');
    var key = input ? input.dataset.key : null;
    if (!key) return;

    stepperEl.querySelector('[data-action="inc"]').addEventListener('click', function () {
      var newQty = parseInt(input.value, 10) + 1;
      cartChange(key, newQty);
    });

    stepperEl.querySelector('[data-action="dec"]').addEventListener('click', function () {
      var newQty = Math.max(0, parseInt(input.value, 10) - 1);
      cartChange(key, newQty);
    });
  });

  // Direct input change (debounced)
  var inputTimers = {};
  document.querySelectorAll('.cart-qty__input').forEach(function (input) {
    input.addEventListener('change', function () {
      var key = this.dataset.key;
      var qty = Math.max(0, parseInt(this.value, 10) || 0);
      clearTimeout(inputTimers[key]);
      inputTimers[key] = setTimeout(function () { cartChange(key, qty); }, 400);
    });
  });

  // Remove buttons
  document.querySelectorAll('.cart-item__remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      cartChange(this.dataset.key, 0);
    });
  });

  // Upsell "Add" — bound to CLICK, not submit.
  //
  // These cards live inside the cart form, and a nested <form> is dropped by the
  // parser, taking the checkout button's form association with it. So the card
  // renders a plain button and this listener does the work the form would have.
  // Same reasoning as the discount control below.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rm-upsell-add]');
    if (!btn) return;

    e.preventDefault();
    var id = btn.getAttribute('data-rm-upsell-add');
    if (!id || btn.disabled) return;

    var label = btn.querySelector('[data-rm-add-label]');
    btn.disabled = true;
    if (label) label.textContent = 'Adding…';

    // Attribution (upsell proposal #1). The leading underscore hides the
    // property from the buyer at checkout; it still reaches the order as a line
    // customAttribute, which is the only way to count what the upsell sold.
    // Curated (server-rendered) cards never pass through render(), so they fall
    // back to their DOM position and source 'curated'.
    var card = btn.closest('.rm-cart__upsell-card');
    var slot = (card && card.dataset.slot) ||
      (card && card.parentNode ? String([].indexOf.call(card.parentNode.children, card) + 1) : '0');
    var source = (card && card.dataset.source) || 'curated';
    var upsellBox = document.getElementById('cart-upsell');
    var seed = (upsellBox && upsellBox.dataset.productId) || '';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: id,
        quantity: 1,
        properties: { _upsell: slot + '|' + source + '|' + seed }
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        if (label) label.textContent = 'Added ✓';
        // Reload so the line items, totals and the upsell row all reflect it.
        window.location.reload();
      })
      .catch(function () {
        btn.disabled = false;
        if (label) label.textContent = 'Try again';
      });
  });

  // ── Discount code ─────────────────────────────────────────────────────────
  //
  // This used to do window.location.href = '/checkout?discount=' + code, which
  // threw the buyer into checkout on any keystroke — no validation, no message,
  // and no way back if the code was wrong or expired.
  //
  // /cart/update.js has taken a `discount` parameter since 2025-05. It applies
  // the code to the CART, keeps the buyer here, and answers with
  // discount_codes: [{ code, applicable }] — so a bad code is a visible "no"
  // instead of a dead end. Verified against this store on 2026-09-03: CART5 ->
  // applicable true and total_price drops; a nonsense code -> applicable false
  // and the total is untouched.
  //
  // The outcome is always applied by RELOADING rather than by patching this
  // page, because changing a cart's discount state RE-KEYS every line: the same
  // variant came back as
  //   ...:d8664555b6d80ad856b1e6d59062b5ae  before
  //   ...:5d986c27c6aab0c57a9f6717f731a151  after
  // and every id, data-key and quantity control here is built from that key. A
  // patched page would look right and then fail the next time the buyer touched
  // a stepper. The message survives the reload in sessionStorage.
  //
  // Bound to the button's click, not a form submit: this control lives INSIDE
  // the cart form, and a nested <form> is dropped by the parser, so the old
  // submit listener could never fire.
  var note = el('cart-discount-note');
  var setNote = function (text, kind) {
    if (!note) return;
    note.textContent = text;
    note.className = 'rm-cart__discount-note' + (kind ? ' rm-cart__discount-note--' + kind : '');
  };
  var stashNote = function (text, kind) {
    try {
      sessionStorage.setItem('rm-cart-note', JSON.stringify({ text: text, kind: kind }));
      return true;
    } catch (e) {
      return false;
    }
  };

  // Pick up the message left by the reload above, once.
  (function () {
    var stashed = null;
    try {
      stashed = sessionStorage.getItem('rm-cart-note');
      sessionStorage.removeItem('rm-cart-note');
    } catch (e) {}
    if (!stashed) return;
    try {
      var parsed = JSON.parse(stashed);
      setNote(parsed.text, parsed.kind);
    } catch (e) {}
  })();

  // ── Trade pricing ─────────────────────────────────────────────────────────
  //
  // Volume pricing is for installers we contact directly, never the public. Each
  // prospect has a PERSONAL pair of codes on the two trade discounts in the admin:
  // TR10-<ref> (10% off 5+ mounts) and TR15-<ref> (15% off 10+), where <ref> is
  // their prospect id from 3drm-sales. Their email links carry ?ref=<prospect id>
  // (stashed by the layout as `rm_ref`), and the email prints both codes for a
  // buyer who checks out on another device.
  //
  // History: there used to be one shared pair of codes, printed on the public
  // trade pages, and opening a trade page was enough to have them applied. A
  // retail buyer sent there by an AI assistant used one in Oct 2026. So nothing
  // public names a code any more, a page visit marks nobody as trade, and a
  // sequence-level ref (seq-...) or another site's ?ref= cannot unlock a
  // discount: only a prospect id can, and only because codes exist for it.
  // (This file ships to every browser: never write a real code in a comment.)
  //
  // Three rules keep this from fighting the buyer:
  //   1. A code the buyer entered themselves is never replaced, unless it is one
  //      of their own TR codes, which only ever moves to the right tier.
  //   2. One attempt per (code, quantity). A ref with no codes behind it gets
  //      applicable:false from Shopify, and without the guard this would reload
  //      the page forever.
  //   3. It reloads rather than patches, for the re-keying reason given below.
  var TRADE_RE = /^TR(10|15)-([A-Z0-9-]{4,24})$/;
  function storedRef() {
    // Prospect ids look like 1s6rmfx or w-halley; a sequence-level ref
    // (seq-msp-unifi) is shared by everyone on that sequence and has no codes.
    try {
      var ref = localStorage.getItem('rm_ref') || '';
      return /^[A-Za-z0-9-]{4,24}$/.test(ref) && !/^seq-/i.test(ref) ? ref.toUpperCase() : '';
    } catch (e) { return ''; }
  }
  function tradeKey(cartData) {
    // The prospect whose codes this cart should carry: the one already typed in,
    // else the one their email link left behind.
    var typed = (cartData.discount_codes || []).map(function (d) {
      return String(d.code).toUpperCase().match(TRADE_RE);
    }).filter(Boolean)[0];
    return typed ? typed[2] : storedRef();
  }
  function tradePricing(cartData) {
    if (!cartData) return;
    var key = tradeKey(cartData);
    if (!key) return;
    var count = cartData.item_count || 0;
    var want = count >= 10 ? 'TR15-' + key : (count >= 5 ? 'TR10-' + key : '');
    var isOurs = function (c) { return TRADE_RE.test(c); };
    var codes = (cartData.discount_codes || []).map(function (d) {
      return { code: String(d.code).toUpperCase(), applicable: !!d.applicable };
    });
    var theirs = codes.filter(function (d) { return d.applicable && !isOurs(d.code); });
    if (theirs.length) return;                           // rule 1: their code, their choice
    var live = codes.filter(function (d) { return d.applicable && isOurs(d.code); });
    // A trade code stays ATTACHED when the cart drops under its minimum, just
    // marked applicable:false. The price is right but the dead code rides into
    // checkout and errors there, so it counts as something to clear.
    var stale = codes.filter(function (d) { return !d.applicable && isOurs(d.code); });
    if ((live[0] ? live[0].code : '') === want && !(want === '' && stale.length)) return;
    var attempt = want + ':' + count;
    try {
      if (sessionStorage.getItem('rm-trade-try') === attempt) return;   // rule 2
      sessionStorage.setItem('rm-trade-try', attempt);
    } catch (e) { return; }                              // no storage, no guard, no attempt
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: want })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (updated) {
        if (!updated) return;
        var ok = (updated.discount_codes || []).some(function (d) {
          return d.applicable && String(d.code).toUpperCase() === want;
        });
        if (want && ok) {
          stashNote('Trade pricing applied: ' + (want.indexOf('TR15-') === 0 ? '15% off 10 or more mounts.' : '10% off 5 or more mounts.'), 'ok');
        } else if (!want) {
          stashNote('Trade pricing starts at 5 mounts.', '');
        } else {
          // No codes behind this ref (or below its minimum): take the dead code
          // back off so it cannot error at checkout, and leave the page alone.
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: '' })
          }).catch(function () {});
          return;
        }
        window.location.reload();
      })
      .catch(function () { /* never let pricing break the cart. */ });
  }
  // On load, from the cart as the server sees it, for a visitor with a prospect
  // ref. A typed TR code is re-tiered on the next quantity change instead, so an
  // ordinary shopper's cart never makes this request.
  if (storedRef()) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(tradePricing)
      .catch(function () {});
  }

  // ── Packing-insert code ───────────────────────────────────────────────────
  //
  // A shopper who came from the packing insert QR keeps the insert's 20% price on products in
  // a raised discount-test phase: BOX20 goes on when one of those is in the cart and comes off
  // when none is left. The rules and the one-attempt guard live in snippets/rm-insert-offer
  // (window.rmInsert); this only says which lines are tagged and reloads on a change, for the
  // same line re-keying reason as the code box below. The tagged set is rendered server-side,
  // and only ever shrinks on this page, so a removed line can never count as tagged.
  var INSERT_VARIANTS = ((el('cart-form') || {}).dataset || {}).insertVariants || '';
  var insertTagged = function (item) {
    return INSERT_VARIANTS.split(',').indexOf(String(item.variant_id)) !== -1;
  };
  function insertPricing(cartData) {
    if (!window.rmInsert || !window.rmInsert.isVisitor()) return;
    window.rmInsert.apply(cartData, insertTagged).then(function (changed) {
      if (!changed) return;
      if (window.rmInsert.plan(cartData, insertTagged) === window.rmInsert.code) stashNote(window.rmInsert.note, 'ok');
      window.location.reload();
    });
  }
  // rmInsert is defined by an inline script at the end of <body>; wait for parsing to finish
  // in case this bundle runs first.
  (function (fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn();
  })(function () {
    if (!window.rmInsert || !window.rmInsert.isVisitor()) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(insertPricing)
      .catch(function () {});
  });

  var discountApply = el('cart-discount-apply');
  if (discountApply) {
    var post = function (code) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: code })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart update failed: ' + r.status);
        return r.json();
      });
    };

    discountApply.addEventListener('click', function (e) {
      e.preventDefault();
      var input = el('cart-discount-input');
      var code = input ? input.value.trim() : '';
      if (!code) {
        setNote('Please enter a discount code.', 'error');
        return;
      }

      discountApply.disabled = true;
      setNote('Applying code…', '');

      post(code)
        .then(function (cart) {
          var applied = (cart.discount_codes || []).filter(function (d) { return d.applicable; });
          if (applied.length) {
            stashNote(applied[0].code + ' applied. It carries through to checkout.', 'ok');
            window.location.reload();
            return null;
          }
          // Drop the rejected code rather than letting it ride into checkout and
          // fail again there.
          return post('').then(function () {
            if (stashNote('That code is not valid for this cart.', 'error')) {
              window.location.reload();
            } else {
              // No sessionStorage to carry a message through a reload, so say it
              // here instead. Nothing was applied, so nothing on the page is stale.
              discountApply.disabled = false;
              setNote('That code is not valid for this cart.', 'error');
            }
            return null;
          });
        })
        .catch(function () {
          discountApply.disabled = false;
          setNote('We could not reach the cart. Please try that code again.', 'error');
        });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
(function () {
  // Sort submits on change; the <noscript> button covers the JS-off case.
  var sortSel = document.getElementById('col-sort');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      this.form.submit();
    });
  }

// Collection search — fetches ALL products in collection via AJAX, not just paginated ones
var colSearchInput = document.getElementById('col-search-input');
var colSearchHint  = document.getElementById('col-search-hint');
var colSearchForm  = document.getElementById('col-search-form');

if (colSearchInput && colSearchForm) {
  var colHandle      = colSearchForm.dataset.collectionHandle || '';
  var colAllProducts = null;   // null = not yet loaded
  var colLoading     = false;
  var colTimer       = null;
  var colOrigGrid    = null;   // saved original grid HTML
  var COL_MAX_RESULTS = 60;    // cap the DOM write on broad queries

  function colMoney(str) {
    var n = parseFloat(str);
    return isNaN(n) ? (str || '') : '$' + n.toFixed(2).replace(/\.00$/, '');
  }

  function colBuildCard(p) {
    var url   = '/products/' + p.handle;
    var v     = p.variants && p.variants[0] ? p.variants[0] : {};
    var price = parseFloat(v.price || 0);
    var cmp   = parseFloat(v.compare_at_price || 0);
    var esc   = function (s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); };

    var sale = cmp > price
      ? '<span class="rm-card__sale">-' + Math.round((cmp - price) / cmp * 100) + '%</span>' : '';
    var was  = cmp > price
      ? '<s class="rm-card__was">' + colMoney(v.compare_at_price) + '</s>' : '';

    var img = p.images && p.images[0]
      ? '<img class="rm-card__img" src="' + p.images[0].src.replace(/\?.*$/, '') + '?width=600" alt="'
        + esc(p.title) + '" loading="lazy" width="600" height="600">'
      : '<div class="rm-card__img rm-card__img--empty"></div>';

    // Variant count is not in products.json per-variant availability terms we
    // can trust, so anything with more than one variant links out to choose —
    // same rule as the server-rendered card.
    var multi = (p.variants || []).length > 1;
    var action = multi
      ? '<a href="' + url + '" class="rm-card__add rm-card__add--options">Options</a>'
      : '<form method="post" action="/cart/add" class="rm-card__form" data-rm-add>'
        + '<input type="hidden" name="id" value="' + (v.id || '') + '">'
        + '<input type="hidden" name="quantity" value="1">'
        + '<button type="submit" class="rm-card__add"><span data-rm-add-label>Add</span></button></form>';

    return '<div class="rm-card" data-product-id="' + (p.id || '') + '">'
      + '<a href="' + url + '" class="rm-card__media" tabindex="-1" aria-hidden="true">' + img + sale + '</a>'
      + '<div class="rm-card__body">'
      + '<a href="' + url + '" class="rm-card__title">' + esc(p.title) + '</a>'
      + '<p class="rm-card__meta">Ships in 1\u20133 days</p>'
      + '<div class="rm-card__foot"><div class="rm-card__prices">'
      + '<span class="rm-card__price">' + colMoney(v.price) + '</span>' + was
      + '</div>' + action + '</div></div></div>';
  }

  // Normalize for matching: lowercase, punctuation → spaces.
  // "MS-01" → "ms 01", '19" Rack' → "19 rack", "M710q-M920q" → "m710q m920q"
  function colNorm(s) {
    return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  // Tags are worth searching — "pfsense", "proxmox", "zigbee", "FG-80F" and
  // brand tags like "Unifi" (on the UNVR Instant, whose title never says Unifi)
  // only exist as tags. But boilerplate tags are on nearly every product and
  // would flood results, so drop any tag common enough to be meaningless.
  // Frequency-based rather than a hardcoded list, so it keeps working as the
  // catalogue grows. Needs a reasonable sample to be meaningful.
  var COL_COMMON_TAG_RATIO = 0.25;
  var colCommonTags = null;
  function colBuildCommonTags(products) {
    colCommonTags = {};
    if (products.length < 20) return;
    var freq = {};
    products.forEach(function(p) {
      var seen = {};
      (p.tags || []).forEach(function(t) {
        var k = colNorm(t);
        if (k && !seen[k]) { seen[k] = 1; freq[k] = (freq[k] || 0) + 1; }
      });
    });
    var cutoff = products.length * COL_COMMON_TAG_RATIO;
    Object.keys(freq).forEach(function(k) {
      if (freq[k] > cutoff) colCommonTags[k] = 1;
    });
  }

  function colHaystack(p) {
    var parts = [p.title, p.vendor || '', p.product_type || ''];
    (p.tags || []).forEach(function(t) {
      var k = colNorm(t);
      if (k && !(colCommonTags && colCommonTags[k])) parts.push(k);
    });
    return colNorm(parts.join(' '));
  }

  // Token match: every word of the query must hit, in any order.
  // A token hits if it prefixes any word in the haystack, or appears in the
  // punctuation-stripped haystack (so "ms01" still finds "MS-01").
  function colMatches(q, p) {
    var hay      = colHaystack(p);
    var words    = hay.split(' ');
    var squashed = hay.replace(/ /g, '');
    // Titles write the format as 19" / 10", never "19 inch", so a typed "inch"
    // has nothing to land on. Drop it rather than fail the whole query.
    var tokens   = colNorm(q).split(' ').filter(function(t) {
      return t && t !== 'inch';
    });
    if (!tokens.length) return false;
    return tokens.every(function(t) {
      // Bare numbers match whole words only. Prefix-matching them is far too
      // loose: "10" would otherwise hit 10G, 1005T and 108P, so searching
      // "10 inch" inside the 19" collection returned 47 unrelated products.
      var exact = /^\d+$/.test(t);
      for (var i = 0; i < words.length; i++) {
        if (exact ? words[i] === t : words[i].indexOf(t) === 0) return true;
      }
      return exact ? false : squashed.indexOf(t) !== -1;
    });
  }

  // Keep the "N products" toolbar honest while a search is active.
  // Pass null to restore the unfiltered server-rendered count.
  var colCountEl   = document.getElementById('col-results-count');
  var colCountOrig = colCountEl ? colCountEl.innerHTML : null;
  function colSetCount(n) {
    if (!colCountEl) return;
    if (n === null) { colCountEl.innerHTML = colCountOrig; return; }
    colCountEl.textContent = n + ' product' + (n === 1 ? '' : 's') + ' matching search';
  }

  // Reflect the query in the URL so results are shareable and survive refresh.
  function colSyncUrl(q) {
    if (!window.history || !history.replaceState) return;
    var u = new URL(window.location.href);
    if (q) { u.searchParams.set('q', q); } else { u.searchParams.delete('q'); }
    history.replaceState(null, '', u.pathname + (u.search ? u.search : '') + u.hash);
  }

  function colRenderResults(q) {
    var grid = document.getElementById('col-products-grid');
    var pag  = document.querySelector('.col-pagination');
    if (!grid) return;

    if (!q) {
      if (colOrigGrid !== null) { grid.innerHTML = colOrigGrid; colOrigGrid = null; }
      if (pag) pag.style.display = '';
      if (colSearchHint) { colSearchHint.textContent = ''; colSearchHint.className = 'col-search__hint'; }
      colSetCount(null);
      colSyncUrl('');
      return;
    }

    if (colOrigGrid === null) colOrigGrid = grid.innerHTML;
    if (pag) pag.style.display = 'none';

    var matches = (colAllProducts || []).filter(function(p) {
      return colMatches(q, p);
    });

    colSyncUrl(q);
    colSetCount(matches.length);

    if (matches.length === 0) {
      grid.innerHTML = '<div class="rm-col__empty">'
        + '<p class="rm-col__empty-title">No products found</p>'
        + '<p class="rm-col__empty-body">Nothing in this collection matches \u201C' + q.replace(/</g, '&lt;') + '\u201D. '
        + 'Press Enter to search the whole store, or request a custom design.</p>'
        + '</div>';
      if (colSearchHint) {
        colSearchHint.textContent = 'No results. Try a different term or press Enter to search the full store.';
        colSearchHint.className = 'col-search__hint col-search__hint--none';
      }
    } else {
      // Cap the DOM write — a broad query can match the whole collection.
      var shown = matches.slice(0, COL_MAX_RESULTS);
      grid.innerHTML = shown.map(colBuildCard).join('');
      if (colSearchHint) {
        colSearchHint.textContent = matches.length > shown.length
          ? 'Showing ' + shown.length + ' of ' + matches.length + ' matches. Narrow your search, or press Enter to search the full store.'
          : matches.length + ' product' + (matches.length === 1 ? '' : 's') + ' found in this collection.';
        colSearchHint.className = 'col-search__hint';
      }
    }
  }

  function colFetchAll(cb) {
    if (!colHandle) { cb(); return; }
    var all = [];
    function getPage(n) {
      fetch('/collections/' + colHandle + '/products.json?limit=250&page=' + n)
        .then(function(r) { return r.json(); })
        .then(function(d) {
          var batch = d.products || [];
          all = all.concat(batch);
          if (batch.length === 250) {
            getPage(n + 1);
          } else {
            colAllProducts = all;
            colBuildCommonTags(all);
            cb();
          }
        })
        .catch(function() { colAllProducts = all; colBuildCommonTags(all); cb(); });
    }
    getPage(1);
  }

  function colRunSearch(q) {
    var grid = document.getElementById('col-products-grid');
    if (!q) { colRenderResults(''); return; }

    if (colAllProducts !== null) { colRenderResults(q); return; }

    if (!colLoading) {
      colLoading = true;
      if (colOrigGrid === null && grid) colOrigGrid = grid.innerHTML;
      if (grid) grid.innerHTML = '<div class="rm-col__loading">Loading collection\u2026</div>';
      if (colSearchHint) { colSearchHint.textContent = ''; }
      colFetchAll(function() {
        colLoading = false;
        colRenderResults(colSearchInput.value.trim());
      });
    }
  }

  colSearchInput.addEventListener('input', function() {
    var q = this.value.trim();
    clearTimeout(colTimer);
    if (!q) { colRunSearch(''); return; }
    colTimer = setTimeout(function() { colRunSearch(q); }, 300);
  });

  colSearchInput.addEventListener('search', function() {
    if (!this.value) colRunSearch('');
  });

  // Restore a query carried in the URL (shared link, refresh, back button).
  var colInitialQ = new URLSearchParams(window.location.search).get('q');
  if (colInitialQ) {
    colSearchInput.value = colInitialQ;
    colRunSearch(colInitialQ.trim());
  }
}})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-orders"] && !Shopify.designMode) return;
  try {
    
(function() {
  var coCurrentStep = 1;
  var coMaxReached = 1; // tracks how far the user has progressed

  // ── Prefill from a link ──
  //
  // 2026-10-01: AI assistants find our catalog through Shopify's agent layer,
  // but had no way to start a custom request for a device we don't list. So an
  // assistant can now build a link like ?brand=Dell&model=R210&rack=19 and this
  // fills the form in. It ONLY fills: the customer reads every step, types their
  // own email and presses Submit, and the request then meets the same captcha,
  // honeypot, spam gate, rate limit and dedup as a typed one.
  //
  // ⚠️ Hostile input by definition (anyone can craft the link):
  //   · an allow-list of fields, never email or name, so nobody can send a
  //     request in someone else's name;
  //   · values go in through .value only, never innerHTML, so nothing executes;
  //   · lengths clamped, control characters and every URL stripped, so a link
  //     cannot carry spam links into the email or the queue;
  //   · dimensions must be plain numbers.
  // The Worker records prefill='link' on the row; a burst of them raises the
  // PREFILL_SPIKE watchdog alert.
  var coPrefilled = false;
  // 'search' when the shopper came from a site search that found no mount
  // (the typeahead's "Request a custom design" link adds src=search and their
  // words as model). Their own words, so the note and the row say so.
  var coPrefillSrc = 'link';
  (function coPrefillFromLink() {
    try {
      var params = new URLSearchParams(window.location.search);
      var clean = function (v, max) {
        // Control characters out (newlines kept, tabs become spaces). Done by
        // char code, which reads more plainly than an escape-range regex.
        var plain = String(v || '').split('').map(function (c) {
          var n = c.charCodeAt(0);
          return n === 10 ? c : (n < 32 || n === 127) ? ' ' : c;
        }).join('');
        return plain
          .replace(/\b(?:https?:\/\/|www\.)\S+/gi, '')
          .replace(/[ \t]{2,}/g, ' ')
          .trim()
          .slice(0, max);
      };
      var put = function (id, v) {
        var el = document.getElementById(id);
        if (el && v) { el.value = v; coPrefilled = true; }
      };
      put('brand', clean(params.get('brand'), 120));
      put('model', clean(params.get('model'), 160));
      put('context', clean(params.get('notes'), 1000));
      put('port-notes', clean(params.get('ports'), 500));
      ['w', 'd', 'h'].forEach(function (k) {
        var v = String(params.get(k) || '').trim();
        if (/^\d{1,3}(\.\d{1,2})?$/.test(v)) put('dim-' + k, v);
      });
      var rack = String(params.get('rack') || '').replace(/[^0-9]/g, '');
      if (rack === '10' || rack === '19') {
        document.querySelectorAll('input[name="rack-type-ui"]').forEach(function (r) {
          if (r.value.indexOf(rack + '"') === 0) { r.checked = true; coPrefilled = true; }
        });
      }
      if (!coPrefilled) return;
      if (params.get('src') === 'search') coPrefillSrc = 'search';
      var note = document.getElementById('co-prefill-note');
      if (note && coPrefillSrc === 'search') {
        note.innerHTML = '<strong>We started this with what you searched for.</strong> '
          + 'Add the brand and exact model if you know them, then your email, and submit.';
      }
      if (note) note.hidden = false;
      // Drop the prefill keys from the address bar (UTMs stay: submit reads
      // them), so a reload never pastes the link back over the customer's edits.
      ['brand', 'model', 'rack', 'w', 'd', 'h', 'ports', 'notes', 'src'].forEach(function (k) { params.delete(k); });
      var qs = params.toString();
      if (window.history && history.replaceState) {
        history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
      }
    } catch (e) { /* a bad link leaves an empty form, never a broken one */ }
  })();

  // ── Validate a given step, return true if valid ──
  function validateStep(n) {
    if (n === 1) {
      var brand = document.getElementById('brand');
      var model = document.getElementById('model');
      var ok = true;
      if (!brand || !brand.value.trim()) {
        if (brand) brand.classList.add('error');
        var e = document.getElementById('err-brand');
        if (e) e.classList.add('show');
        ok = false;
      } else {
        brand.classList.remove('error');
        var e = document.getElementById('err-brand');
        if (e) e.classList.remove('show');
      }
      if (!model || !model.value.trim()) {
        if (model) model.classList.add('error');
        var e = document.getElementById('err-model');
        if (e) e.classList.add('show');
        ok = false;
      } else {
        model.classList.remove('error');
        var e = document.getElementById('err-model');
        if (e) e.classList.remove('show');
      }
      return ok;
    }
    return true; // steps 2 and 3 have no required fields
  }

  // ── Navigate to step n ──
  window.coGoStep = function(n) {
    // Allow going back freely; going forward requires validating current step
    if (n > coCurrentStep) {
      if (!validateStep(coCurrentStep)) return;
    }
    // Don't allow skipping ahead past max reached + 1
    if (n > coMaxReached + 1) return;

    document.querySelectorAll('.form-step').forEach(function(s) { s.classList.remove('active'); });
    var target = document.getElementById('step-' + n);
    if (target) target.classList.add('active');

    document.querySelectorAll('.progress-step').forEach(function(s, i) {
      s.classList.remove('active', 'done');
      if (i + 1 < n) s.classList.add('done');
      if (i + 1 === n) s.classList.add('active');
    });

    coCurrentStep = n;
    // Funnel: the first time each step is reached (site weak spots, 2026-10-25),
    // so the report can say which step loses people. Never carries a form value.
    if (n > coMaxReached && window.rmTrack) window.rmTrack('co_form_step', { step: String(n), prefill: coPrefilled ? '1' : '' });
    if (n > coMaxReached) coMaxReached = n;

    var formBody = document.querySelector('.form-body');
    if (formBody) formBody.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  // ── Compile hidden fields + build email body on submit ──
  //
  // The request is DUAL-WRITTEN: the Shopify contact form posts and emails
  // exactly as it always has, and a typed copy also goes to the intake Worker so
  // triage starts within ~60s instead of waiting on an email sweep. The email is
  // the safety net — if the Worker is down, nothing about the customer's
  // experience or CJ's inbox changes.
  var CO_INTAKE_URL = 'https://rack-mounts-sku-api.waynesworld.workers.dev/custom-requests';
  var CO_GEO_URL = 'https://rack-mounts-sku-api.waynesworld.workers.dev/geo';

  // ── Email opt-in default: pre-ticked for US visitors only ──
  //
  // ⚠️ Not `localization.country`: one Shopify market can report US for every
  // visitor, and a pre-ticked box is not consent in the EU, UK or Canada. /geo
  // answers with Cloudflare's view of the connection. Anything but a clean "US"
  // inside 2 seconds (error, timeout, null, another country) leaves it unticked.
  // The Worker re-checks the country at submit, so this only sets what is shown.
  //
  // Touched = the visitor changed the box, either way. A late /geo answer never
  // overrides a visitor who already touched it.
  var coOptInDefault = 'unchecked';
  var coOptInTouched = false;
  (function () {
    var box = document.getElementById('co-marketing-optin');
    if (!box) return;
    box.addEventListener('change', function () { coOptInTouched = true; });
    try {
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctrl) ctrl.abort(); timer = null; }, 2000);
      fetch(CO_GEO_URL, { method: 'GET', credentials: 'omit', signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (timer === null) return; // arrived after the 2s cut-off
          clearTimeout(timer);
          if (d && d.country === 'US' && !coOptInTouched) {
            box.checked = true;
            coOptInDefault = 'checked';
          }
        })
        .catch(function () { /* stays unticked */ });
    } catch (e) { /* stays unticked */ }
  })();

  // How the session started (`rm_attr` in sessionStorage) is written by the theme
  // LAYOUT, not here — it has to run on the page they arrive on, and this page is
  // usually not it. See layout/theme.liquid. Do not re-add a writer here: a
  // second one appends this page to the trail twice.

  // ── One click, one row ──
  //
  // Shopify's hCaptcha script intercepts this form's submit and posts it itself
  // once the challenge passes. When the challenge never completes (hcaptcha.com
  // blocked by a privacy extension, or the popup dismissed) it logs "form submit
  // failed" to the console and does nothing visible: no navigation, no email.
  // The customer clicks Submit again, and this listener used to beacon a fresh
  // row to the Worker on every click (2026-09-28: five rows, five pings, one
  // request, no email). So:
  //   · one key per page load AND per payload, sent as `client_key`, so the
  //     Worker answers a re-click with the row it already has;
  //   · no second beacon at all for an unchanged form from this page;
  //   · the button reports "Submitting…", and if the page is still here after
  //     6s it is handed back with a hint, instead of looking dead.
  // An edited form (a second device from the same page) is a new payload, a new
  // key and a new row, which is what it should be.
  var coKeys = {};
  var coBeaconed = {};

  // ── The success-page resend ──
  //
  // 2026-09-25..27: three requests (Sapphire, SMLIGHT, Topping) reached CJ as
  // Shopify emails but never reached the Worker. Nothing on the Worker side
  // could have discarded them, so the submit-time beacon never arrived, and
  // the rows only existed once customer-reply-drafts backfilled them from Gmail
  // hours later. So the submit handler keeps a copy of exactly what it
  // beaconed, and the "Request submitted!" page sends it once more. The copy
  // carries the same client_key, so when the beacon did land the Worker answers
  // with the row it already has and nothing changes; when it did not, this is
  // the row. `intake_path` records which send made it (a `success_retry` row is
  // a rescued drop), which is how we know whether this is earning its keep.
  //
  // sessionStorage, so the copy lives in this tab only and dies with it. A copy
  // older than CO_PENDING_MAX_MS is stale (a success page reached some other
  // way) and is dropped unsent. Every step is inside try/catch: storage can be
  // blocked, and nothing here may ever get in the customer's way.
  var CO_PENDING_KEY = 'co_pending_request';
  var CO_PENDING_MAX_MS = 30 * 60 * 1000;
  function coStashPending(fd) {
    try {
      var copy = {};
      fd.forEach(function (v, k) { copy[k] = v; });
      sessionStorage.setItem(CO_PENDING_KEY, JSON.stringify({ at: Date.now(), fields: copy }));
    } catch (e) { /* storage blocked: the beacon is all we have, as before */ }
  }
  (function coResendFromSuccessPage() {
    try {
      if (!document.querySelector('.success-state')) return;
      var raw = sessionStorage.getItem(CO_PENDING_KEY);
      if (!raw) return;
      var pending = JSON.parse(raw);
      if (!pending || !pending.fields || !(Date.now() - pending.at < CO_PENDING_MAX_MS)) {
        sessionStorage.removeItem(CO_PENDING_KEY);
        return;
      }
      var fd = new FormData();
      Object.keys(pending.fields).forEach(function (k) { fd.append(k, pending.fields[k]); });
      fd.set('intake_path', 'success_retry');
      // FormData keeps this a simple request, the same as the beacon, so there
      // is no preflight. The page stays put, so a plain fetch is enough.
      fetch(CO_INTAKE_URL, { method: 'POST', body: fd, credentials: 'omit' })
        .then(function (r) {
          // Kept on a failure so a reload within the window tries again; the
          // client_key means a second success cannot make a second row.
          if (r.ok) sessionStorage.removeItem(CO_PENDING_KEY);
        })
        .catch(function () { /* the email went; step 2c of customer-reply-drafts is the backstop */ });
    } catch (e) { /* never in the customer's way */ }
  })();
  function coKeyFor(sig) {
    if (!coKeys[sig]) {
      var k = '';
      try { if (window.crypto && crypto.randomUUID) k = crypto.randomUUID(); } catch (e) { k = ''; }
      if (!k) k = 'k' + Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
      coKeys[sig] = k;
    }
    return coKeys[sig];
  }
  var coBtnLabel = '';
  var coBtnTimer = null;
  function coSubmitting(btn) {
    if (!btn) return;
    if (!coBtnLabel) coBtnLabel = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Submitting\u2026';
    clearTimeout(coBtnTimer);
    coBtnTimer = setTimeout(function () {
      btn.disabled = false;
      btn.innerHTML = coBtnLabel;
      var hint = document.getElementById('co-submit-hint');
      if (hint) hint.classList.add('show');
      // Still on the page 6s after Submit: the captcha never completed. Once
      // per page; the count is how often hCaptcha stands between a buyer and us.
      if (!coStallTracked && window.rmTrack) {
        coStallTracked = true;
        window.rmTrack('co_form_stall', { step: String(coCurrentStep) });
      }
    }, 6000);
  }
  var coStallTracked = false;

  // Leaving with a started, unsent form: which step they were on and how far
  // they got. Started = any focus or typing inside the form, as co_form_start.
  (function coLeaveTracking() {
    var touched = false, sent = false;
    var form = document.getElementById('btn-submit') && document.getElementById('btn-submit').closest('form');
    if (!form) return;
    form.addEventListener('focusin', function () { touched = true; }, true);
    form.addEventListener('input', function () { touched = true; }, true);
    // After the form's own checks: a submit they blocked (no email) is not a send.
    form.addEventListener('submit', function (e) { setTimeout(function () { if (!e.defaultPrevented) sent = true; }, 0); }, true);
    window.addEventListener('pagehide', function () {
      if (!touched || sent || !window.rmTrack) return;
      sent = true; // once
      window.rmTrack('co_form_leave', { step: String(coCurrentStep), max: String(coMaxReached),
                                        stalled: coStallTracked ? '1' : '' });
    });
  })();

  var submitBtn = document.getElementById('btn-submit');
  var coTracked = false;
  if (submitBtn) {
    var form = submitBtn.closest('form');
    form.addEventListener('submit', function(e) {
      // Validate step 4 contact fields
      var fname = document.getElementById('contact-fname');
      var lname = document.getElementById('contact-lname');
      var emailField = document.getElementById('contact-email');
      var ok = true;

      if (!emailField || !emailField.value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailField.value.trim())) {
        var er = document.getElementById('err-email');
        if (er) er.classList.add('show');
        if (emailField) emailField.classList.add('error');
        ok = false;
      } else {
        var er = document.getElementById('err-email');
        if (er) er.classList.remove('show');
        emailField.classList.remove('error');
      }
      if (!ok) { e.preventDefault(); return; }

      // Disabling the button here does not stop the submission: the event has
      // already fired, and the button carries no name, so it is not form data.
      coSubmitting(submitBtn);

      // Funnel event for the website report (snippets/rm-events), once per
      // page however many times hCaptcha makes the buyer press Submit. Not part
      // of the intake beacon below and never carries a form value.
      if (!coTracked && window.rmTrack) {
        coTracked = true;
        window.rmTrack('co_form_submit', { prefill: coPrefilled ? '1' : '', src: coPrefilled ? coPrefillSrc : '' });
      }

      // Gather values
      var brandVal    = document.getElementById('brand').value.trim();
      var modelVal    = document.getElementById('model').value.trim();
      var rackEl      = document.querySelector('input[name="rack-type-ui"]:checked');
      var rackVal     = rackEl ? rackEl.value : '';
      var contextVal  = (document.getElementById('context') || {}).value || '';
      var dimW        = (document.getElementById('dim-w') || {}).value || '';
      var dimD        = (document.getElementById('dim-d') || {}).value || '';
      var dimH        = (document.getElementById('dim-h') || {}).value || '';
      var dimsVal     = [dimW && 'W:'+dimW+'mm', dimD && 'D:'+dimD+'mm', dimH && 'H:'+dimH+'mm'].filter(Boolean).join(', ') || 'Not provided';
      var portVal     = (document.getElementById('port-notes') || {}).value || '';
      var matEl       = document.querySelector('input[name="material-ui"]:checked');
      var matVal      = 'PETG';
      if (matEl && matEl.dataset.other === 'true') {
        matVal = (document.getElementById('other-material-text') || {}).value || 'Special Request';
      } else if (matEl) {
        matVal = matEl.value;
      }
      var colEl       = document.querySelector('input[name="color-ui"]:checked');
      var colVal      = colEl ? colEl.value : 'Matte Black';
      if (colEl && colEl.dataset.custom === 'true') colVal = (document.getElementById('custom-color-text') || {}).value || colVal;
      var keystoneVal = (document.getElementById('keystone-val') || {}).value || '0';
      var refEl       = document.getElementById('contact-referral');
      var refVal      = refEl ? refEl.value : '';
      var fnameVal    = fname ? fname.value.trim() : '';
      var lnameVal    = lname ? lname.value.trim() : '';
      var fullName    = [fnameVal, lnameVal].filter(Boolean).join(' ') || 'Not provided';

      // Populate contact[name] for Shopify
      document.getElementById('h-name').value = fullName;

      // Populate individual hidden fields (appear in Shopify email as extra properties)
      document.getElementById('h-brand').value    = brandVal;
      document.getElementById('h-model').value    = modelVal;
      document.getElementById('h-rack').value     = rackVal;
      document.getElementById('h-context').value  = contextVal;
      document.getElementById('h-dims').value     = dimsVal;
      document.getElementById('h-ports').value    = portVal;
      document.getElementById('h-material').value  = matVal;
      document.getElementById('h-color').value     = colVal;
      document.getElementById('h-keystones').value = keystoneVal;
      document.getElementById('h-referral').value  = refVal;
      try { document.getElementById('h-ref').value = localStorage.getItem('rm_ref') || ''; } catch (e) { /* storage blocked */ }

      // Build a readable email body
      var body = [
        '=== CUSTOM MOUNT REQUEST ===',
        '',
        'CUSTOMER: ' + fullName,
        'EMAIL: ' + emailField.value.trim(),
        refVal ? 'REFERRAL: ' + refVal : '',
        coPrefilled ? (coPrefillSrc === 'search'
          ? 'STARTED FROM: a site search that found no mount'
          : 'STARTED FROM: a prefilled link (likely an AI assistant)') : '',
        '',
        '--- DEVICE INFO ---',
        'Brand:    ' + brandVal,
        'Model:    ' + modelVal,
        'Rack:     ' + rackVal,
        contextVal ? 'Notes:    ' + contextVal : '',
        '',
        '--- DIMENSIONS ---',
        'Size:  ' + dimsVal,
        portVal ? 'Ports: ' + portVal : '',
        '',
        '--- MATERIAL & FINISH ---',
        'Material:  ' + matVal,
        'Color:     ' + colVal,
        'Keystones: ' + keystoneVal,
        '',
        '==========================='
      ].filter(function(l) { return l !== undefined; }).join('\n');

      document.getElementById('h-body').value = body;

      // Remove the first_name/last_name fields so Shopify doesn't treat them as extra contact properties
      if (fname) fname.removeAttribute('name');
      if (lname) lname.removeAttribute('name');

      // ── Dual-write: the same request, typed, straight to the intake Worker ──
      //
      // ⚠️ This must NEVER interfere with the real submission. No preventDefault,
      // nothing awaited, the whole thing inside try/catch. If any of it fails the
      // customer's request still reaches CJ by email exactly as it does today.
      try {
        var fd = new FormData();
        fd.append('name', fullName);
        fd.append('email', emailField.value.trim());
        // Read from the markup, not from Liquid. This is a section javascript
        // block, which Shopify serves as a STATIC asset and never renders Liquid
        // inside — an interpolation here ships as literal text and breaks the JS.
        // Theme check catches it; it caught exactly this on 2026-09-16.
        var coPage = document.querySelector('.co-page');
        fd.append('country_code', (coPage && coPage.dataset.country) || '');
        fd.append('device_brand', brandVal);
        fd.append('device_model', modelVal);
        fd.append('rack_type', rackVal);
        fd.append('context', contextVal);
        fd.append('dimensions', dimsVal);
        fd.append('port_notes', portVal);
        fd.append('material', matVal);
        fd.append('color', colVal);
        fd.append('keystones', keystoneVal);
        fd.append('referral', refVal);
        fd.append('body', body);
        fd.append('prefill', coPrefilled ? coPrefillSrc : '');
        var coSig = emailField.value.trim() + '\n' + body;
        fd.append('client_key', coKeyFor(coSig));
        var hp = document.getElementById('co-website');
        fd.append('website', hp ? hp.value : '');

        // Email-marketing opt-in.
        //
        // ⚠️ FormData can only carry strings, so the booleans arrive as "true" or
        // "false". Always send all three, so the Worker sees explicit values
        // rather than absences. It subscribes only on opt_in "true" AND either
        // touched "true" or a Cloudflare country of US at submit time.
        var optIn = document.getElementById('co-marketing-optin');
        fd.append('marketing_opt_in', optIn && optIn.checked === true ? 'true' : 'false');
        fd.append('marketing_opt_in_default', coOptInDefault);
        fd.append('marketing_opt_in_touched', coOptInTouched ? 'true' : 'false');

        // ── Where this visit came from ──
        //
        // The Referral dropdown above is what the customer SAYS. This is what the
        // browser did, which is a different fact and often a different answer.
        //
        // ⚠️ WHY THIS EXISTS, and what it is NOT.
        //
        // For a request that CONVERTS, none of this is needed: Shopify puts the
        // whole journey on the resulting Order (first and last visit, landing
        // page, referrer, source, UTMs), and the worker pulls it from there.
        //
        // This is for the requests that NEVER buy. They produce no order, so
        // Shopify has no journey for them and never will, and these fields are
        // the only record of where they came from that will ever exist. Those
        // are also the ones worth learning from.
        //
        // ⚠️ _shopify_y / _shopify_s are NOT a join key, though they look like
        // the obvious one. CustomerVisit and CustomerJourney hang off an Order
        // and nothing else -- there is no query that takes a visitor token and
        // returns a session. They are captured because they are free and might
        // match a future export, not because anything can resolve them today.
        // (An earlier version of this comment claimed they were the join key.
        // They are not; checking the API is what found that.)
        //
        var cookie = function (name) {
          var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
          return m ? m.pop() : '';
        };
        fd.append('shopify_y', cookie('_shopify_y'));
        fd.append('shopify_s', cookie('_shopify_s'));

        // What the layout stashed when they arrived, plus UTMs off the current
        // URL in case they came back with fresh ones. The stash may be empty
        // (storage blocked); then the row simply carries less.
        var params = new URLSearchParams(window.location.search);
        var stash = {};
        try { stash = JSON.parse(sessionStorage.getItem('rm_attr') || '{}'); } catch (e) { stash = {}; }
        ['source', 'medium', 'campaign', 'term', 'content'].forEach(function (k) {
          fd.append('utm_' + k, params.get('utm_' + k) || stash['utm_' + k] || '');
        });
        fd.append('landing_page', stash.landing_page || window.location.pathname);
        fd.append('pages_seen', (stash.pages || []).join(',').slice(0, 1000));

        // ⚠️ The SESSION's referrer, not this page's. By the time someone reaches
        // the form they have usually browsed the store, so `document.referrer`
        // here is one of our own pages — which told us nothing. The layout
        // captures the real one on arrival; document.referrer stays the fallback
        // for a session whose storage is blocked, or who landed straight here.
        fd.append('referrer', stash.referrer || document.referrer || '');

        // The browser's FIRST visit (the layout's `rm_first`, localStorage, 90
        // days), as one JSON string. The session fields above only see the visit
        // the form was sent from; this is the one that found us. The Worker
        // parses and clamps it, and an empty value simply means less is known.
        var rmFirst = '';
        try { rmFirst = localStorage.getItem('rm_first') || ''; } catch (e) { rmFirst = ''; }
        fd.append('first_touch', rmFirst.slice(0, 4000));

        // The trade outreach ref the layout keeps in localStorage. The intake
        // Worker drops fields it does not know, so until it learns this one the
        // ref reaches CJ through the email copy (the hidden contact[ref] input).
        var rmRef = '';
        try { rmRef = localStorage.getItem('rm_ref') || ''; } catch (e) { rmRef = ''; }
        fd.append('rm_ref', rmRef);

        // sendBeacon, not fetch: the native submit navigates away immediately and
        // would cancel an in-flight request. A beacon is queued by the browser and
        // delivered regardless of the navigation. FormData also keeps this a
        // CORS-safelisted content type, so there is no preflight to fail — and the
        // response being unreadable cross-origin does not matter for a
        // fire-and-forget.
        if (coBeaconed[coSig]) {
          // Same form, same page: the Worker already has this one.
        } else {
          coBeaconed[coSig] = true;
          // Before the send, so the success page can resend exactly this.
          coStashPending(fd);
          var sent = false;
          if (navigator.sendBeacon) {
            fd.set('intake_path', 'beacon');
            sent = navigator.sendBeacon(CO_INTAKE_URL, fd);
          }
          if (!sent) {
            fd.set('intake_path', 'fetch');
            // keepalive makes the same promise as a beacon for a request that has
            // to outlive the page.
            fetch(CO_INTAKE_URL, { method: 'POST', body: fd, keepalive: true, mode: 'no-cors' })
              .catch(function () { /* the email still went. */ });
          }
        }
      } catch (err) {
        /* Never let this break a sale. The email still went. */
      }
    });
  }


  // ── Keystone picker ──
  window.coSetKeystone = function(btn) {
    document.querySelectorAll('.keystone-btn').forEach(function(b) { b.classList.remove('keystone-btn--active'); });
    btn.classList.add('keystone-btn--active');
    var field = document.getElementById('keystone-val');
    if (field) field.value = btn.dataset.val;
  };

  // ── FAQ accordion ──
  document.querySelectorAll('.faq-item').forEach(function(item) {
    item.querySelector('.faq-q').addEventListener('click', function() {
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var header = document.getElementById('rm-header');
  if (!header) return;

  /* ── Search panel ── */
  var toggle = document.getElementById('rm-search-toggle');
  var panel  = document.getElementById('rm-search-panel');
  var input  = document.getElementById('rm-search-input');

  function closeSearch() {
    if (!panel || panel.hidden) return;
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
  }

  if (toggle && panel) {
    toggle.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open && input) input.focus();
    });
  }

  /* ── Mobile drawer ── */
  var burger = document.getElementById('rm-burger');
  var drawer = document.getElementById('rm-drawer');

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    document.body.style.overflow = '';
    if (burger) {
      burger.setAttribute('aria-expanded', 'false');
      burger.focus();
    }
  }

  if (burger && drawer) {
    burger.addEventListener('click', function () {
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      burger.setAttribute('aria-expanded', 'true');
      var first = drawer.querySelector('.rm-drawer__link');
      if (first) first.focus();
    });

    drawer.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-rm-drawer-close')) closeDrawer();
    });
  }

  /* Escape closes whichever surface is open. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer();
    closeSearch();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mounting-answer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wrap = document.querySelector('.ma-wrap');
  if (!wrap) return;
  var WORKER_URL = (wrap.dataset.workerUrl || '').replace(/\/$/, '');
  var token = new URLSearchParams(window.location.search).get('t') || '';

  var show = function (id) {
    ['ma-loading', 'ma-ask', 'ma-done', 'ma-unknown'].forEach(function (x) {
      var el = document.getElementById(x);
      if (el) el.hidden = (x !== id);
    });
  };

  // A token that is missing or malformed never reaches the Worker. It cannot be
  // a real link, and asking anyway would turn a mistyped URL into a 404 log line
  // that looks like an outage.
  if (!/^[0-9a-f]{32}$/.test(token) || !WORKER_URL) { show('ma-unknown'); return; }

  var DONE = {
    separate: 'We will make them up as separate mounts.',
    combine: 'We will build them the way you have set out.'
  };

  function finish(answer) {
    document.getElementById('ma-done-sub').textContent =
      (DONE[answer] || '') + ' Nothing else needed from you. If you change your mind, reply to ' +
      'your order email before it ships and we will sort it out.';
    show('ma-done');
  }

  var ITEMS = [];
  // ⚠️ Two, not three. A row can physically take three pieces, but that is the
  // 19in_row family — a matched set we do not build to order — so we neither
  // advertise nor accept it. The Worker is the authority; this is the fallback
  // if its value is missing.
  var MAX_PER_UNIT = 2;

  function post(payload) {
    return fetch(WORKER_URL + '/m/' + token, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function note() {
    return (document.getElementById('ma-note').value || '').trim() || null;
  }

  function fail(msg) {
    var err = document.getElementById('ma-err');
    err.textContent = msg || 'Sorry, that did not save. Try again, or just reply to your order email.';
    err.hidden = false;
  }

  // One row per mount, each choosing which unit it belongs to. A select rather than
  // drag-and-drop: this is opened on a phone, from an email, by someone who wants to
  // spend ten seconds on it.
  function renderRows() {
    var host = document.getElementById('ma-rows');
    host.textContent = '';
    // At most one unit per mount can ever be needed, and offering more just makes
    // the list longer than the question.
    var unitCount = Math.max(1, Math.ceil(ITEMS.length / MAX_PER_UNIT) + 1);
    ITEMS.forEach(function (item, idx) {
      var row = document.createElement('div');
      row.className = 'ma-row';

      var title = document.createElement('span');
      title.className = 'ma-row-title';
      title.textContent = item.title || ('Mount ' + (idx + 1));
      row.appendChild(title);

      if (item.u) {
        var u = document.createElement('span');
        u.className = 'ma-row-u';
        u.textContent = item.u + 'U';
        row.appendChild(u);
      }

      var sel = document.createElement('select');
      sel.dataset.idx = String(idx);
      var own = document.createElement('option');
      own.value = '';
      own.textContent = 'On its own';
      sel.appendChild(own);
      for (var u2 = 1; u2 <= unitCount; u2++) {
        var opt = document.createElement('option');
        opt.value = String(u2);
        opt.textContent = 'Unit ' + u2;
        sel.appendChild(opt);
      }
      row.appendChild(sel);
      host.appendChild(row);
    });
  }

  // A buyer who already answered and comes back must SEE their answer. Without
  // this the form re-renders blank and reads as "it did not save" — the one thing
  // likelier than silence to make somebody email about it. Their answer stays
  // changeable until the print box claims it, deliberately, so this shows the
  // current state rather than locking it.
  function applyPrevious(groups) {
    if (!groups || !groups.length) return;
    var unit = 0;
    groups.forEach(function (g) {
      if (g.length < 2) return;
      unit += 1;
      g.forEach(function (idx) {
        var sel = document.querySelector('#ma-rows select[data-idx="' + idx + '"]');
        if (sel) sel.value = String(unit);
      });
    });
    notePrevious();
  }

  function markPrevious(answer) {
    if (!answer) return;
    Array.prototype.forEach.call(document.querySelectorAll('#ma-pair .ma-opt'), function (b) {
      if (b.dataset.answer === answer) b.style.borderColor = 'var(--rm-accent, #1543f0)';
    });
    notePrevious();
  }

  function notePrevious() {
    var host = document.getElementById('ma-previous');
    if (host) host.hidden = false;
  }

  function collectGroups() {
    var byUnit = {};
    var groups = [];
    Array.prototype.forEach.call(document.querySelectorAll('#ma-rows select'), function (sel) {
      var idx = Number(sel.dataset.idx);
      var unit = sel.value;
      if (!unit) { groups.push([idx]); return; }
      (byUnit[unit] = byUnit[unit] || []).push(idx);
    });
    Object.keys(byUnit).sort().forEach(function (k) { groups.push(byUnit[k]); });
    return groups;
  }

  // Ask the Worker what state this token is in before offering a choice, so a
  // buyer who already answered — or whose answer has already been acted on —
  // is not invited to change something we can no longer honour.
  fetch(WORKER_URL + '/m/' + token, { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('unknown')); })
    .then(function (data) {
      if (data.settled) { finish(data.answer); return; }
      ITEMS = data.items || [];
      MAX_PER_UNIT = data.maxPerUnit || 2;
      document.getElementById('ma-max').textContent = String(MAX_PER_UNIT);
      // Two mounts is an either/or. Three or more needs a plan, because "combine"
      // stops meaning one thing the moment there is more than one way to do it.
      if (ITEMS.length > 2) {
        renderRows();
        applyPrevious(data.groups);
        document.getElementById('ma-many').hidden = false;
      } else {
        markPrevious(data.answer);
        document.getElementById('ma-pair').hidden = false;
      }
      show('ma-ask');
    })
    .catch(function () { show('ma-unknown'); });

  var save = document.getElementById('ma-save');
  save.addEventListener('click', function () {
    var groups = collectGroups();
    var tooBig = groups.filter(function (g) { return g.length > MAX_PER_UNIT; });
    if (tooBig.length) {
      // Caught here as well as at the Worker, so the buyer is told by the thing
      // they are looking at rather than by a failed request.
      fail('A single rack unit holds at most ' + MAX_PER_UNIT + ' mounts. Split the big one up.');
      return;
    }
    document.getElementById('ma-err').hidden = true;
    save.disabled = true;
    post({ groups: groups, answer_text: note() })
      .then(function (data) {
        if (data.settled) { finish(data.answer); return; }
        if (!data.ok) throw new Error(data.error || 'Could not save that.');
        finish(data.answer);
      })
      .catch(function (e) { save.disabled = false; fail(e && e.message); });
  });

  var buttons = Array.prototype.slice.call(document.querySelectorAll('.ma-opt'));
  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var answer = btn.dataset.answer;
      var err = document.getElementById('ma-err');
      err.hidden = true;
      buttons.forEach(function (b) { b.disabled = true; });

      post({ answer: answer, answer_text: note() })
        .then(function (data) {
          if (data.settled) { finish(data.answer || answer); return; }
          if (!data.ok) throw new Error(data.error || 'Could not save that.');
          finish(answer);
        })
        .catch(function () {
          buttons.forEach(function (b) { b.disabled = false; });
          fail();
        });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Accordion
  document.querySelectorAll('.faq-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item    = this.closest('.faq-item');
      var answer  = item.querySelector('.faq-a');
      var isOpen  = item.classList.contains('open');

      // Close all in same list
      var list = item.closest('.faq-list');
      list.querySelectorAll('.faq-item.open').forEach(function(o) {
        o.classList.remove('open');
        var a = o.querySelector('.faq-a');
        a.hidden = true;
        o.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('open');
        answer.hidden = false;
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Category tabs
  var tabs = document.querySelectorAll('.faq-tab');
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      tabs.forEach(function(t) { t.classList.remove('faq-tab--active'); });
      this.classList.add('faq-tab--active');
      var cat = this.dataset.cat;
      document.querySelectorAll('.faq-group').forEach(function(g) {
        if (g.dataset.group === cat) { g.removeAttribute('hidden'); }
        else { g.setAttribute('hidden', ''); }
      });
    });
  });
})();

  /* ── Search filter ──
     Filters across every category at once and hides the rail while a query is
     active: an answer the buyer can see but that lives under another tab is
     worse than no filter at all. */
  var faqSearch = document.getElementById('faq-search');
  if (faqSearch) {
    var rail = document.getElementById('faq-tabs');
    var groups = document.querySelectorAll('.faq-group');
    var none = document.getElementById('faq-no-results');

    faqSearch.addEventListener('input', function () {
      var q = this.value.trim().toLowerCase();

      if (!q) {
        if (rail) rail.hidden = false;
        groups.forEach(function (g, i) { g.hidden = i !== 0; });
        document.querySelectorAll('.rm-faq__item').forEach(function (it) { it.hidden = false; });
        if (none) none.hidden = true;
        var active = document.querySelector('.faq-tab--active');
        if (active) {
          var cat = active.dataset.cat;
          groups.forEach(function (g) { g.hidden = g.dataset.group !== cat; });
        }
        return;
      }

      if (rail) rail.hidden = true;
      var hits = 0;
      groups.forEach(function (g) { g.hidden = false; });
      document.querySelectorAll('.rm-faq__item').forEach(function (it) {
        var match = (it.dataset.q || '').indexOf(q) !== -1;
        it.hidden = !match;
        if (match) hits++;
      });
      /* A category with nothing left in it should disappear too. */
      groups.forEach(function (g) {
        g.hidden = g.querySelectorAll('.rm-faq__item:not([hidden])').length === 0;
      });
      if (none) none.hidden = hits > 0;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  // Buyer-photo viewer. Every [data-rphoto] link in the section joins one
  // stream (deduped by image), so the strip and the cards step through the
  // same photos. Arrows, swipe and the keyboard move; Esc, the close button,
  // a backdrop tap or the browser Back button close.
  // Events, for the product-page report, go to the product section's events
  // URL and are skipped while that is blank:
  //   review_photo_open  own=1|0, from=strip|card
  //   review_photo_close viewed=<distinct photos seen this open>
  (function () {
    var dlg = document.querySelector('.rm-plb');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var root = dlg.closest('.pr-wrap');
    var img = dlg.querySelector('.rm-plb__img');
    var stream = [], at = 0, seen = {}, pushed = false;

    function beacon(name, extra) {
      var anchor = document.getElementById('product-form-anchor');
      var url = anchor && anchor.dataset.eventsUrl;
      if (!url || !navigator.sendBeacon) return;
      var fd = new FormData();
      fd.append('event', name);
      fd.append('product_id', anchor.dataset.productId || '');
      fd.append('device', window.matchMedia('(max-width: 899px)').matches ? 'mobile' : 'desktop');
      try { var sid = sessionStorage.getItem('rm_sid'); if (sid) fd.append('sid', sid); } catch (e) {}
      for (var k in extra) fd.append(k, extra[k]);
      navigator.sendBeacon(url, fd);
    }

    function build() {
      var keys = {};
      stream = [];
      root.querySelectorAll('[data-rphoto]').forEach(function (a) {
        if (keys[a.dataset.key]) return;
        keys[a.dataset.key] = 1;
        stream.push(a);
      });
    }

    function text(sel, value) {
      var el = dlg.querySelector(sel);
      el.textContent = value || '';
      el.hidden = !value;
      return el;
    }

    function show(i) {
      at = (i + stream.length) % stream.length;
      var d = stream[at].dataset;
      seen[d.key] = 1;
      img.src = d.full;
      img.alt = d.own === '1' ? 'Buyer photo of this mount' : 'Buyer photo of another mount';
      var n = Number(d.rating) || 0;
      text('.rm-plb__stars', '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n))
        .setAttribute('aria-label', n + ' out of 5 stars');
      text('.rm-plb__count', stream.length > 1 ? (at + 1) + ' / ' + stream.length : '');
      var prod = dlg.querySelector('.rm-plb__product');
      prod.textContent = '';
      if (d.own === '1') {
        prod.textContent = 'This mount';
      } else if (d.product && d.productUrl) {
        prod.appendChild(document.createTextNode('Other mount: '));
        var link = document.createElement('a');
        link.href = d.productUrl;
        link.textContent = d.product;
        prod.appendChild(link);
      } else {
        prod.textContent = 'Other mount of ours';
      }
      prod.classList.toggle('rm-plb__product--other', d.own !== '1');
      text('.rm-plb__body', d.body);
      text('.rm-plb__by', [d.name, d.date, d.source].filter(Boolean).join(' · '));
      dlg.querySelectorAll('.rm-plb__nav').forEach(function (b) { b.hidden = stream.length < 2; });
      // Warm the next photo so stepping feels instant.
      if (stream.length > 1) { var pre = new Image(); pre.src = stream[(at + 1) % stream.length].dataset.full; }
    }

    function open(a) {
      build();
      seen = {};
      var i = 0;
      for (var j = 0; j < stream.length; j++) if (stream[j].dataset.key === a.dataset.key) { i = j; break; }
      show(i);
      dlg.showModal();
      try { history.pushState(Object.assign({}, history.state, { rmPhoto: 1 }), ''); pushed = true; } catch (e) { pushed = false; }
      beacon('review_photo_open', { own: a.dataset.own || '0', from: a.closest('.rm-rphotos') ? 'strip' : 'card' });
    }

    function close(fromHistory) {
      if (!dlg.open) return;
      dlg.close();
      beacon('review_photo_close', { viewed: Object.keys(seen).length });
      if (pushed && !fromHistory) { pushed = false; history.back(); }
      pushed = false;
    }

    root.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-rphoto]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      open(a);
    });
    dlg.querySelector('.rm-plb__close').addEventListener('click', function () { close(false); });
    dlg.querySelector('.rm-plb__nav--prev').addEventListener('click', function () { show(at - 1); });
    dlg.querySelector('.rm-plb__nav--next').addEventListener('click', function () { show(at + 1); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(false); });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(false); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(at - 1);
      if (e.key === 'ArrowRight') show(at + 1);
    });
    window.addEventListener('popstate', function () { if (dlg.open) close(true); });

    var x0 = null;
    img.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    img.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) show(at + (dx < 0 ? 1 : -1));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
(function() {
  // ── Variant data (read from JSON script tags, not Liquid) ──
  var variantsEl = document.getElementById('product-variants-json');
  var optionsEl  = document.getElementById('product-options-json');
  if (!variantsEl || !optionsEl) return;
  var variants = JSON.parse(variantsEl.textContent);
  var options  = JSON.parse(optionsEl.textContent);

  // Current selections (mirror defaults from selected variant)
  var current = (function() {
    var sel = {};
    // Start from the variant the server rendered (it honours ?variant= in the
    // link), so an ad or shared link opens on that option.
    var idEl0 = document.getElementById('variant-id');
    var startId = idEl0 ? Number(idEl0.value) : 0;
    var defaultVariant = variants.find(function(v) { return v.id === startId; })
      || variants.find(function(v) { return v.available; }) || variants[0];
    if (defaultVariant) {
      options.forEach(function(opt, i) {
        sel[i] = defaultVariant.options[i];
      });
    }
    return sel;
  })();

  function findVariant() {
    return variants.find(function(v) {
      return options.every(function(_, i) {
        return v.options[i] === current[i];
      });
    }) || null;
  }

  function updatePrice(variant) {
    var priceEl = document.getElementById('product-price');
    var stickyPrice = document.getElementById('sticky-price');
    if (!priceEl || !variant) return;

    var fmt = function(cents) {
      return (window.Shopify && window.Shopify.formatMoney)
        ? Shopify.formatMoney(cents)
        : '$' + (cents / 100).toFixed(2);
    };

    // Must rebuild with the SAME classes the server rendered, including the
    // save pill — otherwise switching variant silently drops the sale styling.
    var html = '';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
      html = '<span class="product-buybox__price product-buybox__price--sale rm-pdp__price">' + fmt(variant.price) + '</span>'
           + '<span class="product-buybox__compare rm-pdp__was">' + fmt(variant.compare_at_price) + '</span>'
           + '<span class="rm-pdp__save">Save ' + pct + '%</span>';
    } else {
      html = '<span class="product-buybox__price rm-pdp__price">' + fmt(variant.price) + '</span>';
    }
    priceEl.innerHTML = html;
    if (stickyPrice) stickyPrice.textContent = fmt(variant.price);
  }

  function updateATCBtn(variant) {
    var btn = document.getElementById('add-to-cart-btn');
    var stickyBtn = document.getElementById('sticky-atc-btn');
    var available = variant && variant.available;
    var label = available ? 'Add to Cart' : 'Sold Out';
    [btn, stickyBtn].forEach(function(el) {
      if (!el) return;
      el.textContent = label;
      el.disabled = !available;
    });
  }

  function updateVariantInput(variant) {
    var input = document.getElementById('variant-id');
    if (input && variant) input.value = variant.id;

    // Keep the sticky bar's compare-at in step with the variant, or it keeps
    // advertising the first variant's saving against a different price.
    var stickyWas = document.querySelector('.rm-pdp__sticky-price s');
    if (stickyWas && variant) {
      var fmt2 = function (c) {
        return (window.Shopify && window.Shopify.formatMoney)
          ? Shopify.formatMoney(c) : '$' + (c / 100).toFixed(2);
      };
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        stickyWas.textContent = fmt2(variant.compare_at_price);
        stickyWas.hidden = false;
      } else {
        stickyWas.hidden = true;
      }
    }
  }

  function onOptionChipClick(e) {
    var chip = e.currentTarget;
    var optIndex = parseInt(chip.dataset.optionIndex, 10);
    var value = chip.dataset.value;

    // Update current selection
    current[optIndex] = value;

    // Update chip UI
    var allChips = document.querySelectorAll('[data-option-index="' + optIndex + '"]');
    allChips.forEach(function(c) { c.classList.remove('selected'); });
    chip.classList.add('selected');

    // Update selected label
    var label = document.getElementById('option-selected-' + optIndex);
    if (label) label.textContent = value;

    // Update variant
    var variant = findVariant();
    if (variant) {
      updatePrice(variant);
      updateATCBtn(variant);
      updateVariantInput(variant);
      updateShipping();
      if (typeof showVariantImage === 'function') showVariantImage(variant);
      // Keep the address on the picked option, so a copied or shared link
      // opens on it. replaceState: picking options should not fill Back.
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', variant.id);
        history.replaceState(history.state, '', u.toString());
      }
    }
  }

  // ── Custom logo fields ──
  // The form is novalidate, so required fields are checked here. A capture
  // listener runs before the theme's other submit listeners (events, search).
  var logoFields = document.getElementById('rm-logo-fields');
  if (logoFields) {
    var logoForm = logoFields.closest('form');
    logoForm.addEventListener('submit', function (e) {
      var file = document.getElementById('rm-logo-file');
      var colors = document.getElementById('rm-logo-colors');
      var err = document.getElementById('rm-logo-error');
      var missing = [];
      [file, colors].forEach(function (el) { el.classList.remove('is-missing'); });
      if (!file.files || !file.files.length) missing.push(file);
      if (!colors.value.trim()) missing.push(colors);
      if (file.files && file.files[0] && file.files[0].size > 20 * 1024 * 1024) missing.push(file);
      if (missing.length) {
        e.preventDefault();
        e.stopImmediatePropagation();
        missing.forEach(function (el) { el.classList.add('is-missing'); });
        err.textContent = missing.indexOf(file) > -1
          ? (file.files && file.files[0] ? 'That file is over 20 MB. Please upload a smaller version.' : 'Please upload your logo file.')
          : 'Please tell us which color goes where.';
        err.hidden = false;
        missing[0].focus();
      }
    }, true);
  }

  // ── Buy now ──
  var buyNow = document.getElementById('buy-now-btn');
  if (buyNow) {
    buyNow.addEventListener('click', function (e) {
      e.preventDefault();
      var idEl = document.getElementById('variant-id');
      var qtyEl = document.getElementById('qty-input');
      if (!idEl) return;

      var was = buyNow.textContent;
      buyNow.disabled = true;
      buyNow.textContent = 'Taking you to checkout\u2026';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: idEl.value, quantity: parseInt(qtyEl && qtyEl.value, 10) || 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          // A packing-insert shopper buying a product in a raised test phase skips the cart
          // page, so BOX20 has to go on here (snippets/rm-insert-offer). Never blocks checkout.
          var tagged = buyNow.dataset.insertTagged === 'true';
          if (!tagged || !window.rmInsert || !window.rmInsert.isVisitor()) return null;
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (cart) {
              var anchor = document.getElementById('product-form-anchor');
              var pid = anchor ? Number(anchor.dataset.productId) : NaN;
              return window.rmInsert.apply(cart, function (item) { return item.product_id === pid; });
            })
            .catch(function () { return null; });
        })
        .then(function () {
          // Put the browser's first visit on the cart before checkout is
          // created from it (snippets/rm-cart-touch). Never waits long.
          var w = null;
          try { w = window.rmCartTouch && window.rmCartTouch.write(true); } catch (e) { w = null; }
          return Promise.race([w || Promise.resolve(), new Promise(function (r) { setTimeout(r, 800); })]);
        })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () {
          // Fall back to a normal form post rather than stranding the buyer.
          buyNow.disabled = false;
          buyNow.textContent = was;
          var f = document.getElementById('variant-id').closest('form');
          if (f) f.submit();
        });
    });
  }

  // Bind option chips
  document.querySelectorAll('.option-chip').forEach(function(chip) {
    chip.addEventListener('click', onOptionChipClick);
  });

  // ── Gallery thumbnails ──
  var mainImg = document.getElementById('gallery-main-img');
  var filmBox = document.getElementById('gallery-main-video');
  var film = filmBox && filmBox.querySelector('video');
  var filmLogged = false;
  function showFilm(on) {
    if (!filmBox) return;
    filmBox.hidden = !on;
    if (mainImg) mainImg.hidden = on;
    if (!film) return;
    if (on) {
      var p = film.play();
      if (p && p.catch) p.catch(function() {});
    } else {
      film.pause();
    }
  }
  // Film plays, once per page view, for the film metrics. The URL is the
  // section's film_events_url setting; blank = nothing is sent.
  var filmEventsUrl = filmBox ? filmBox.dataset.eventsUrl : '';
  if (film) {
    film.addEventListener('playing', function() {
      if (filmLogged || !filmEventsUrl || !navigator.sendBeacon) return;
      filmLogged = true;
      var fd = new FormData();
      fd.append('event', 'film_play');
      fd.append('product_id', filmBox.dataset.productId || '');
      fd.append('media_id', filmBox.dataset.mediaId || '');
      fd.append('device', window.matchMedia('(max-width: 899px)').matches ? 'mobile' : 'desktop');
      navigator.sendBeacon(filmEventsUrl, fd);
    });
  }
  // The model-viewer library loads on the first 3D pick, through Shopify's
  // own feature loader (content_for_header), never on page load.
  var modelBox = document.getElementById('gallery-main-model');
  var modelUiLoaded = false;
  function showModel(on) {
    if (!modelBox) return;
    modelBox.hidden = !on;
    if (on && mainImg) mainImg.hidden = true;
    if (on && !modelUiLoaded && window.Shopify && Shopify.loadFeatures) {
      modelUiLoaded = true;
      Shopify.loadFeatures([{
        name: 'model-viewer-ui', version: '1.0',
        onLoad: function(err) {
          if (err) return;
          var mv = modelBox.querySelector('model-viewer');
          if (mv && Shopify.ModelViewerUI) new Shopify.ModelViewerUI(mv);
        }
      }]);
    }
  }

  var zoomBtn = document.getElementById('gallery-zoom-btn');
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.product-gallery__thumb'));
  var imageThumbs = thumbs.filter(function(t) { return !t.dataset.mediaType; });
  var shownIdx = 0; // index into imageThumbs of the photo on show
  // Not "current": that name holds the option picks above, and a second var
  // in this same function would overwrite it and break every option chip.
  var counter = document.getElementById('gallery-counter');

  // Picking an option shows that option's own photo (its featured image),
  // so "2x Mounts" changes the picture, not only the price.
  function showVariantImage(variant) {
    var img = variant && (variant.featured_image || (variant.featured_media && variant.featured_media.preview_image));
    if (!img || !img.id) return;
    for (var i = 0; i < imageThumbs.length; i++) {
      if (imageThumbs[i].dataset.imageId === String(img.id)) { selectThumb(imageThumbs[i]); return; }
    }
  }

  function gEvent(name, extra) {
    if (typeof pdpEvent === 'function') pdpEvent(name, extra);
  }

  function selectThumb(thumb) {
    var type = thumb.dataset.mediaType;
    showFilm(type === 'video');
    showModel(type === 'model');
    if (zoomBtn) zoomBtn.hidden = !!type;
    if (!type) {
      shownIdx = imageThumbs.indexOf(thumb);
      if (mainImg) {
        mainImg.hidden = false;
        mainImg.style.opacity = '0';
        setTimeout(function() {
          if (thumb.dataset.srcset) mainImg.srcset = thumb.dataset.srcset;
          mainImg.src = thumb.dataset.src;
          mainImg.alt = thumb.dataset.alt || mainImg.alt;
          mainImg.style.opacity = '1';
        }, 150);
      }
      if (counter) counter.textContent = (shownIdx + 1) + ' / ' + imageThumbs.length;
    } else if (type === 'model') {
      gEvent('gallery_model_open');
    }
    thumbs.forEach(function(t) { t.classList.remove('active'); t.removeAttribute('aria-current'); });
    thumb.classList.add('active');
    thumb.setAttribute('aria-current', 'true');
    if (counter) counter.hidden = !!type;
    if (thumb.scrollIntoView && thumb.parentNode.scrollWidth > thumb.parentNode.clientWidth) {
      thumb.parentNode.scrollTo({ left: thumb.offsetLeft - thumb.parentNode.offsetLeft - 8, behavior: 'smooth' });
    }
  }
  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() { selectThumb(thumb); });
  });

  function stepImage(dir) {
    if (imageThumbs.length < 2) return;
    var next = (shownIdx + dir + imageThumbs.length) % imageThumbs.length;
    selectThumb(imageThumbs[next]);
  }

  // Swipe the main photo on phones. pan-y on the image keeps vertical page
  // scrolling native; only a clearly horizontal drag changes the photo.
  var swipeStart = null;
  var swipeLogged = false;
  if (mainImg && imageThumbs.length > 1) {
    mainImg.addEventListener('touchstart', function(e) {
      var t = e.touches[0];
      swipeStart = { x: t.clientX, y: t.clientY };
    }, { passive: true });
    mainImg.addEventListener('touchend', function(e) {
      if (!swipeStart) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - swipeStart.x;
      var dy = t.clientY - swipeStart.y;
      swipeStart = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      stepImage(dx < 0 ? 1 : -1);
      if (!swipeLogged) { swipeLogged = true; gEvent('gallery_swipe'); }
    }, { passive: true });
  }

  // ── Zoom ──
  var zoom = document.getElementById('rm-zoom');
  var zoomImg = document.getElementById('rm-zoom-img');
  var zoomCount = document.getElementById('rm-zoom-count');
  var zoomIdx = 0;
  function zoomShow(i) {
    if (!zoomImg) return;
    var src, alt;
    if (imageThumbs.length) {
      zoomIdx = (i + imageThumbs.length) % imageThumbs.length;
      src = imageThumbs[zoomIdx].dataset.zoom;
      alt = imageThumbs[zoomIdx].dataset.alt;
    } else if (mainImg) {
      src = mainImg.src.replace(/width=\d+/, 'width=2400');
      alt = mainImg.alt;
    }
    zoomImg.classList.remove('is-zoomed');
    var st = document.getElementById('rm-zoom-stage');
    if (st) st.classList.remove('is-zoomed');
    zoomImg.src = src;
    zoomImg.alt = alt || '';
    if (zoomCount) zoomCount.textContent = imageThumbs.length > 1 ? (zoomIdx + 1) + ' / ' + imageThumbs.length : '';
  }
  function openZoom() {
    if (!zoom || !zoom.showModal) return;
    zoomShow(shownIdx);
    zoom.showModal();
    gEvent('gallery_zoom', { image_index: String(zoomIdx) });
  }
  if (zoom) {
    if (mainImg) mainImg.addEventListener('click', openZoom);
    if (zoomBtn) zoomBtn.addEventListener('click', openZoom);
    document.getElementById('rm-zoom-close').addEventListener('click', function() { zoom.close(); });
    var zPrev = document.getElementById('rm-zoom-prev');
    var zNext = document.getElementById('rm-zoom-next');
    if (zPrev) zPrev.addEventListener('click', function() { zoomShow(zoomIdx - 1); });
    if (zNext) zNext.addEventListener('click', function() { zoomShow(zoomIdx + 1); });
    zoom.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft') zoomShow(zoomIdx - 1);
      if (e.key === 'ArrowRight') zoomShow(zoomIdx + 1);
    });
    // Zoom = the photo at its full file size inside a scrolling stage, centred
    // on the point tapped or clicked; panning is then native scrolling. A
    // click zooms on a computer, a double-tap on a phone (Baymard: support
    // pinch AND double-tap, and load a sharper file for it). Pinch stays the
    // browser's own.
    var stage = document.getElementById('rm-zoom-stage');
    function toggleZoom(clientX, clientY) {
      var r = zoomImg.getBoundingClientRect();
      var fx = (clientX - r.left) / r.width, fy = (clientY - r.top) / r.height;
      var on = !zoomImg.classList.contains('is-zoomed');
      zoomImg.classList.toggle('is-zoomed', on);
      stage.classList.toggle('is-zoomed', on);
      if (on) {
        stage.scrollLeft = fx * zoomImg.offsetWidth - stage.clientWidth / 2;
        stage.scrollTop = fy * zoomImg.offsetHeight - stage.clientHeight / 2;
      }
    }
    var lastTap = 0;
    zoomImg.addEventListener('click', function(e) {
      if (window.matchMedia('(hover: none)').matches) {
        var now = Date.now();
        if (now - lastTap < 320) { toggleZoom(e.clientX, e.clientY); lastTap = 0; } else { lastTap = now; }
        return;
      }
      toggleZoom(e.clientX, e.clientY);
    });
    var zStart = null;
    zoom.addEventListener('touchstart', function(e) {
      if (e.touches.length !== 1 || zoomImg.classList.contains('is-zoomed')) { zStart = null; return; }
      zStart = { x: e.touches[0].clientX, y: e.touches[0].clientY };
    }, { passive: true });
    zoom.addEventListener('touchend', function(e) {
      if (!zStart || (window.visualViewport && window.visualViewport.scale > 1.05)) { zStart = null; return; }
      var dx = e.changedTouches[0].clientX - zStart.x;
      var dy = e.changedTouches[0].clientY - zStart.y;
      zStart = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) zoomShow(zoomIdx + (dx < 0 ? 1 : -1));
    }, { passive: true });
    // A tap on the white space around the photo closes it.
    zoom.addEventListener('click', function(e) {
      if (e.target === zoom || e.target.id === 'rm-zoom-stage') zoom.close();
    });
  }

  // ── AR: "View in your space" ──
  // Shopify's XR script, loaded when the browser is idle; it reveals the
  // button only on AR-capable phones and tablets.
  var xrJson = document.querySelector('[id^="ProductModelJSON-"]');
  function setupXR(err) {
    if (err || !xrJson) return;
    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', function() { setupXR(); }, { once: true });
      return;
    }
    try { window.ShopifyXR.addModels(JSON.parse(xrJson.textContent)); } catch (e) { return; }
    window.ShopifyXR.setupXRElements();
  }
  if (xrJson && window.Shopify && Shopify.loadFeatures) {
    var loadXR = function() { Shopify.loadFeatures([{ name: 'shopify-xr', version: '1.0', onLoad: setupXR }]); };
    if ('requestIdleCallback' in window) requestIdleCallback(loadXR); else setTimeout(loadXR, 1500);
    var xrBtn = document.querySelector('.rm-pdp__xr');
    if (xrBtn) xrBtn.addEventListener('click', function() { gEvent('gallery_ar_open'); });
  }

  // ── Quantity stepper ──
  var qtyInput = document.getElementById('qty-input');
  document.getElementById('qty-minus') && document.getElementById('qty-minus').addEventListener('click', function() {
    var v = parseInt(qtyInput.value, 10);
    if (v > 1) qtyInput.value = v - 1;
  });
  document.getElementById('qty-plus') && document.getElementById('qty-plus').addEventListener('click', function() {
    var v = parseInt(qtyInput.value, 10);
    qtyInput.value = v + 1;
  });

  // ── Tab switching ──
  document.querySelectorAll('.product-tab__btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var target = btn.dataset.tab;
      document.querySelectorAll('.product-tab__btn').forEach(function(b) {
        b.classList.remove('active');
        b.setAttribute('aria-selected', 'false');
      });
      document.querySelectorAll('.product-tab__panel').forEach(function(p) {
        p.classList.remove('active');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-selected', 'true');
      var panel = document.querySelector('[data-panel="' + target + '"]');
      if (panel) panel.classList.add('active');
      // Which tabs get opened, Install guide above all, for the product-page report.
      if (target !== 'overview') pdpEvent('tab_open', { tab: target });
    });
  });

  // ── Sticky ATC bar ──
  var stickyBar = document.getElementById('sticky-atc');
  var stickyBtn = document.getElementById('sticky-atc-btn');
  var mainAtcBtn = document.getElementById('add-to-cart-btn');
  var anchorEl = document.getElementById('product-form-anchor');
  var formId = anchorEl ? anchorEl.dataset.formId : '';

  if (stickyBar && mainAtcBtn) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('visible');
          stickyBar.setAttribute('aria-hidden', 'true');
        } else {
          stickyBar.classList.add('visible');
          stickyBar.setAttribute('aria-hidden', 'false');
        }
      });
    }, { threshold: 0.2 });
    observer.observe(mainAtcBtn);
  }

  // Sticky ATC submits the main form
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function() {
      var mainForm = document.getElementById(formId);
      if (mainForm) mainForm.requestSubmit ? mainForm.requestSubmit() : mainForm.submit();
    });
  }

  // ── Product page events ──
  // One beacon for every product-page metric (film plays, twin clicks,
  // recommendation clicks), to the Worker in the section's events setting.
  // Blank setting = nothing is sent.
  var anchorData = anchorEl ? anchorEl.dataset : {};
  function pdpEvent(name, extra) {
    if (!anchorData.eventsUrl || !navigator.sendBeacon) return;
    var fd = new FormData();
    fd.append('event', name);
    fd.append('product_id', anchorData.productId || '');
    fd.append('device', window.matchMedia('(max-width: 899px)').matches ? 'mobile' : 'desktop');
    // The per-tab id rm-search-events and rm-events send, so these join on it.
    try { var sid = sessionStorage.getItem('rm_sid'); if (sid) fd.append('sid', sid); } catch (e) {}
    Object.keys(extra || {}).forEach(function (k) { fd.append(k, extra[k]); });
    navigator.sendBeacon(anchorData.eventsUrl, fd);
  }

  // ── Delivery line: cost by weight band, arrival by business days ──
  var delivery = document.getElementById('rm-delivery');
  var shipCost = document.getElementById('rm-ship-cost');
  var shipPrice = document.getElementById('rm-ship-price');

  function bandPrice(grams) {
    if (!delivery || !(grams > 0)) return '';
    var oz = grams / 28.3495;
    var bands = (delivery.dataset.bands || '').split(',');
    for (var i = 0; i < bands.length; i++) {
      var parts = bands[i].trim().split(':');
      if (parts.length !== 2) continue;
      if (parts[0] === '*' || oz <= parseFloat(parts[0])) return parts[1];
    }
    return '';
  }

  function updateShipping() {
    if (!delivery || !shipCost) return;
    var variant = findVariant();
    var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
    // Shopify bands the SUM of variant weights, so qty x weight is exactly
    // what checkout charges for this line on its own.
    var price = variant ? bandPrice((variant.weight || 0) * qty) : '';
    shipCost.hidden = !price;
    if (price && shipPrice) shipPrice.textContent = '$' + price;
  }

  function addBusinessDays(from, n) {
    var d = new Date(from.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) n--;
    }
    return d;
  }

  (function fillArrival() {
    var arrival = document.getElementById('rm-arrival');
    var dates = document.getElementById('rm-arrival-dates');
    if (!delivery || !arrival || !dates) return;
    var ds = delivery.dataset;
    var lo = (parseInt(ds.shipMin, 10) || 0) + (parseInt(ds.transitMin, 10) || 0);
    var hi = (parseInt(ds.shipMax, 10) || 0) + (parseInt(ds.transitMax, 10) || 0);
    if (!(lo > 0) || hi < lo) return;
    var now = new Date();
    var a = addBusinessDays(now, lo), b = addBusinessDays(now, hi);
    var fmt = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    var text = fmt(a) + ' to ' + (a.getMonth() === b.getMonth() ? b.getDate() : fmt(b));
    dates.textContent = text;
    arrival.hidden = false;
  })();

  if (qtyInput) {
    ['input', 'change'].forEach(function (ev) { qtyInput.addEventListener(ev, updateShipping); });
    ['qty-minus', 'qty-plus'].forEach(function (id) {
      var b = document.getElementById(id);
      if (b) b.addEventListener('click', updateShipping);
    });
  }

  // ── Twin link (the other rack size) ──
  var twinLink = document.getElementById('rm-twin');
  if (twinLink) {
    twinLink.addEventListener('click', function () {
      pdpEvent('twin_click', { target_id: twinLink.dataset.twinId || '' });
    });
  }

  // ── Recommendations ──
  var recs = document.getElementById('rm-recs');
  if (recs) {
    var recPid = recs.dataset.productId;
    var recRack = recs.dataset.rack || '';
    fetch('/recommendations/products?section_id=rm-product-recommendations'
          + '&product_id=' + encodeURIComponent(recPid) + '&limit=10&intent=related')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var box = document.createElement('div');
        box.innerHTML = html;
        // Same rack size only: baskets are size-pure, and the other size of
        // this very mount already has the twin link above.
        var cards = Array.prototype.slice.call(box.querySelectorAll('.rm-pdp__rec')).filter(function (c) {
          return c.dataset.recId !== recPid && (!recRack || !c.dataset.rack || c.dataset.rack === recRack);
        }).slice(0, 4);
        if (!cards.length) return;

        var wrap = document.createElement('div');
        wrap.className = 'rm-pdp__related';
        var head = document.createElement('div');
        head.className = 'rm-pdp__related-head';
        var h = document.createElement('h2');
        h.className = 'rm-pdp__related-title';
        h.textContent = recs.dataset.title || 'You might also like';
        head.appendChild(h);
        var grid = document.createElement('div');
        grid.className = 'rm-grid rm-pdp__related-grid';
        cards.forEach(function (c, i) { c.dataset.recPos = String(i + 1); grid.appendChild(c); });
        wrap.appendChild(head);
        wrap.appendChild(grid);
        recs.appendChild(wrap);
        // Last thing on the page: after the reviews, so a buyer on the right
        // page reads proof before being offered somewhere else to go. The
        // reviews section sits after this one in templates/product.json,
        // which is merchant-owned, so the row is moved here rather than there.
        var reviews = document.querySelectorAll('.pr-wrap');
        if (reviews.length) {
          var after = reviews[reviews.length - 1];
          after = after.closest('.shopify-section') || after;
          var band = document.createElement('div');
          band.className = 'rm-pdp rm-pdp--recs full-width';
          var inner = document.createElement('div');
          inner.className = 'rm-pdp__inner';
          band.appendChild(inner);
          inner.appendChild(recs);
          after.parentNode.insertBefore(band, after.nextSibling);
        }
        recs.hidden = false;
        pdpEvent('recs_shown', { count: String(cards.length) });

        grid.addEventListener('click', function (e) {
          var a = e.target.closest('a');
          var card = e.target.closest('.rm-pdp__rec');
          if (!a || !card) return;
          pdpEvent('rec_click', { target_id: card.dataset.recId || '', position: card.dataset.recPos || '' });
        });
      })
      .catch(function () { /* no row is better than a broken one */ });
  }

  // ── Scroll reveal ──
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function(el) { revealObserver.observe(el); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  const WORKER_URL = document.getElementById('rf-form-wrap')?.dataset.workerUrl || '';

  // Read URL params to pre-fill product/sku/name
  const params = new URLSearchParams(window.location.search);
  const productName = params.get('product') || '';
  const sku = params.get('sku') || '';
  const customerName = params.get('name') || '';

  if (productName) {
    document.getElementById('rf-product-name').textContent = productName;
    document.getElementById('rf-product-row').style.display = '';
  }
  if (sku) document.getElementById('rf-sku').value = sku;
  if (customerName) document.getElementById('rf-name').value = customerName;

  // Star rating
  let currentRating = 5;
  const stars = document.querySelectorAll('.rf-star');
  const ratingInput = document.getElementById('rf-rating');

  function setRating(val) {
    currentRating = val;
    ratingInput.value = val;
    stars.forEach(s => {
      s.classList.toggle('rf-star--on', parseInt(s.dataset.val) <= val);
    });
  }
  setRating(5);

  // One-tap stars from the review email (CJ, 2026-10-28): ?rating=N preselects the
  // star, logs the tap with the Worker (POST /rate, never published on its own),
  // and puts the cursor in the review box so the buyer adds a few words.
  const tapped = parseInt(params.get('rating') || '', 10);
  if (tapped >= 1 && tapped <= 5) {
    setRating(tapped);
    document.getElementById('rf-tap-stars').textContent = tapped;
    document.getElementById('rf-tap-note').hidden = false;
    try {
      if (WORKER_URL) {
        const tfd = new FormData();
        tfd.append('rating', String(tapped));
        if (sku) tfd.append('sku', sku);
        const ref = window.rmMref && window.rmMref.get();
        if (ref) tfd.append('ref', ref);
        fetch(WORKER_URL + '/rate', { method: 'POST', body: tfd, keepalive: true }).catch(() => {});
      }
    } catch (_) { /* logging a tap must never break the form. */ }
    const box = document.getElementById('rf-body');
    box.placeholder = 'How did it fit? How was the install? One or two sentences is plenty.';
    setTimeout(() => { box.focus({ preventScroll: true }); box.scrollIntoView({ block: 'center', behavior: 'smooth' }); }, 300);
  }

  stars.forEach(star => {
    star.addEventListener('click', () => setRating(parseInt(star.dataset.val)));
    star.addEventListener('mouseenter', () => {
      stars.forEach(s => s.classList.toggle('rf-star--on', parseInt(s.dataset.val) <= parseInt(star.dataset.val)));
    });
  });
  document.getElementById('rf-stars').addEventListener('mouseleave', () => setRating(currentRating));

  // Char count
  const bodyEl = document.getElementById('rf-body');
  const charNum = document.getElementById('rf-char-num');
  bodyEl.addEventListener('input', () => { charNum.textContent = bodyEl.value.length; });

  // Photo upload preview
  const imageInput = document.getElementById('rf-image');
  const previewWrap = document.getElementById('rf-preview-wrap');
  const previewImg = document.getElementById('rf-preview-img');
  const uploadPrompt = document.getElementById('rf-upload-prompt');
  const removeBtn = document.getElementById('rf-remove-img');

  imageInput.addEventListener('change', () => {
    const file = imageInput.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = e => {
      previewImg.src = e.target.result;
      previewWrap.style.display = '';
      uploadPrompt.style.display = 'none';
    };
    reader.readAsDataURL(file);
  });

  removeBtn.addEventListener('click', () => {
    imageInput.value = '';
    previewWrap.style.display = 'none';
    uploadPrompt.style.display = '';
    previewImg.removeAttribute('src');
  });

  // Form submit
  const form = document.getElementById('rf-form');
  const submitBtn = document.getElementById('rf-submit');
  const submitLabel = document.getElementById('rf-submit-label');
  const errorEl = document.getElementById('rf-error');

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.style.display = '';
    errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
  function hideError() { errorEl.style.display = 'none'; }

  form.addEventListener('submit', async e => {
    e.preventDefault();
    hideError();

    const name = document.getElementById('rf-name').value.trim();
    const body = bodyEl.value.trim();

    if (!name) { showError('Please enter your name.'); return; }
    if (body.length < 10) { showError('Please write at least 10 characters in your review.'); return; }
    if (!WORKER_URL) { showError('Review submission is not configured yet.'); return; }

    submitBtn.disabled = true;
    submitLabel.textContent = 'Submitting…';

    const fd = new FormData(form);
    // Email attribution token (snippets/email-mref.liquid), so the review is
    // credited to the review-request email that brought the buyer here.
    try {
      const ref = window.rmMref && window.rmMref.get();
      if (ref && !fd.has('ref')) fd.append('ref', ref);
    } catch (_) { /* attribution must never block a review. */ }

    try {
      const res = await fetch(WORKER_URL + '/submit', { method: 'POST', body: fd });
      const data = await res.json();
      if (!data.ok) throw new Error(data.error || 'Submission failed.');

      document.getElementById('rf-form-wrap').style.display = 'none';
      document.getElementById('rf-header').style.display = 'none';
      document.getElementById('rf-success').style.display = '';
      if (Number(ratingInput.value) >= 4) document.getElementById('rf-follow').hidden = false;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      showError(err.message.replace('Validation: ', ''));
      submitBtn.disabled = false;
      submitLabel.textContent = 'Submit review';
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rm-best-sellers"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-rm-bestsellers]').forEach(function (root) {
    var tabs    = root.querySelectorAll('[data-rm-tab]');
    var panels  = root.querySelectorAll('[data-rm-panel]');
    var viewall = root.querySelector('[data-rm-viewall]');
    var baseLabel = viewall ? viewall.textContent.trim().replace(/\s*\d+\s*→$/, '') : '';

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.dataset.rmTab;

        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('rm-toggle__btn--active', on);
          t.setAttribute('aria-selected', String(on));
        });

        panels.forEach(function (p) {
          p.hidden = p.dataset.rmPanel !== key;
        });

        if (viewall) {
          viewall.href = viewall.dataset['url' + key.toUpperCase()];
          viewall.textContent = baseLabel + ' ' + viewall.dataset['count' + key.toUpperCase()] + ' →';
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rm-guide-finder"] && !Shopify.designMode) return;
  try {
    
(function () {
  var input = document.getElementById('guide-search');
  if (!input) return;
  var cards = document.querySelectorAll('.rm-guides__card');
  var none = document.getElementById('guide-none');

  input.addEventListener('input', function () {
    var q = this.value.trim().toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    var hits = 0;
    cards.forEach(function (c) {
      var hay = (c.dataset.find || '').replace(/[^a-z0-9]+/g, ' ');
      var match = !q || q.split(' ').every(function (t) { return hay.indexOf(t) !== -1; });
      c.hidden = !match;
      if (match) hits++;
    });
    if (none) none.hidden = hits > 0 || !q;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rm-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var el = document.getElementById('rm-hero-type');
  if (!el) return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return; /* server-rendered first word stays put */

  var words = (el.dataset.words || '')
    .split('|')
    .map(function (w) { return w.trim(); })
    .filter(Boolean);
  if (words.length < 2) return;

  var idx = 0, charIdx = words[0].length, deleting = true;
  var PAUSE = 1800, TYPE_SPD = 80, DEL_SPD = 40;

  function paint(text) {
    el.textContent = text;
  }

  function tick() {
    var word = words[idx];

    if (!deleting && charIdx < word.length) {
      charIdx++; paint(word.slice(0, charIdx));
      setTimeout(tick, TYPE_SPD);
    } else if (!deleting && charIdx === word.length) {
      deleting = true;
      setTimeout(tick, PAUSE);
    } else if (deleting && charIdx > 0) {
      charIdx--; paint(word.slice(0, charIdx));
      setTimeout(tick, DEL_SPD);
    } else {
      deleting = false;
      idx = (idx + 1) % words.length;
      setTimeout(tick, 300);
    }
  }

  paint(words[0]);
  setTimeout(tick, PAUSE);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rm-mobile-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-rm-focus-finder]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      /* Prefer the hero finder; fall back to the header search panel. */
      var target = document.getElementById('rm-hero-search');

      if (!target) {
        var toggle = document.getElementById('rm-search-toggle');
        var panel  = document.getElementById('rm-search-panel');
        if (toggle && panel && panel.hidden) toggle.click();
        target = document.getElementById('rm-search-input');
      }

      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target.focus({ preventScroll: true });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rm-shop-by"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rm-shopby-more]');
    if (!btn) return;
    var list = document.getElementById(btn.getAttribute('aria-controls'));
    if (list) list.classList.remove('is-collapsed');
    btn.setAttribute('aria-expanded', 'true');
    btn.hidden = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rm-subscribe-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  var pop = document.getElementById('rm-pop');
  if (!pop) return;

  var KEY = 'rm-pop-seen';
  var remember = parseInt(pop.dataset.remember, 10) || 30;
  var delay = (parseFloat(pop.dataset.delay) || 8) * 1000;
  var scrollPct = parseInt(pop.dataset.scroll, 10) || 0;

  function seen() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return false;
      return Date.now() < parseInt(raw, 10);
    } catch (e) { return false; }
  }
  function remember_() {
    try { localStorage.setItem(KEY, String(Date.now() + remember * 86400000)); } catch (e) {}
  }

  /* Belt and braces: the Liquid gate already keeps the markup off product,
     cart, checkout, search, page, 404, password and account templates. This
     catches anything that slips through, so a buyer mid-purchase is never
     interrupted. */
  var path = window.location.pathname;
  if (/\/(cart|checkouts?|products|search|pages|account|password|challenge)(\/|$)/.test(path)) return;

  var GEO_URL = 'https://rack-mounts-sku-api.waynesworld.workers.dev/geo';
  var REGION_KEY = 'rm-pop-region';
  var region = 'us';

  function track(name, extra) {
    if (!window.rmTrack) return;
    var f = { offer: region };
    for (var k in extra) f[k] = extra[k];
    try { window.rmTrack(name, f); } catch (e) {}
  }

  /* Swap in the International settings. Only text and the tag change; the
     form, layout and success flow are the same. */
  function setText(id, v) {
    var el = document.getElementById(id);
    if (el && v) el.textContent = v;
  }
  function useIntl() {
    var d = pop.dataset;
    if (!d.intlCode) return;
    region = 'intl';
    setText('rm-pop-eyebrow', d.intlEyebrow);
    setText('rm-pop-title', d.intlTitle);
    setText('rm-pop-body', d.intlBody);
    setText('rm-pop-submit', d.intlButton);
    setText('rm-pop-decline', d.intlDecline);
    setText('rm-pop-success-body', d.intlSuccessBody);
    setText('rm-pop-code', d.intlCode);
    setText('rm-pop-success-fine', d.intlSuccessFine);
    var tag = document.getElementById('rm-pop-tag');
    if (tag && d.intlTag) tag.value = d.intlTag;
  }

  var opened = false;
  var lastFocus = null;
  var loadedAt = Date.now();
  var EXIT_MIN_MS = 5000;

  /* `force` is for the post-subscribe reload: the flag was written when the
     popup first opened, and the success view still has to show. */
  function open(force, trig) {
    if (opened) return;
    if (!force && seen()) return;
    opened = true;
    track('popup_view', { trig: trig || 'delay' });
    /* Write the flag the moment it opens, not only on close or success, so a
       reload or a second tab never shows it again. */
    remember_();
    lastFocus = document.activeElement;
    pop.hidden = false;
    document.body.style.overflow = 'hidden';
    var f = pop.querySelector('#rm-pop-email') || pop.querySelector('button');
    if (f) f.focus();
  }

  function close() {
    if (!pop.hidden) track('popup_close', {});
    pop.hidden = true;
    document.body.style.overflow = '';
    remember_();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  var timer = null;

  function trigger(trig) {
    clearTimeout(timer);
    open(false, trig);
  }

  if (!seen()) {
    /* Ask where the visitor is now, so the answer is in long before the
       popup opens. Anything but a clean country code inside 3 s keeps the US
       offer. */
    try {
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      var geoTimer = setTimeout(function () { if (ctrl) ctrl.abort(); geoTimer = null; }, 3000);
      fetch(GEO_URL, { method: 'GET', credentials: 'omit', signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (geoTimer === null || opened) return;
          clearTimeout(geoTimer);
          if (d && typeof d.country === 'string' && /^[A-Z]{2}$/.test(d.country) && d.country !== 'US') useIntl();
        })
        .catch(function () {});
    } catch (e) {}

    timer = setTimeout(function () { trigger('delay'); }, delay);

    if (scrollPct > 0) {
      window.addEventListener('scroll', function onScroll() {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h > 0 && (window.scrollY / h) * 100 >= scrollPct) {
          window.removeEventListener('scroll', onScroll);
          trigger('scroll');
        }
      }, { passive: true });
    }

    /* Desktop exit intent: the pointer heading up past the viewport toward
       the tab bar or address bar. Mouse or trackpad only (pointer: fine), and
       not before 5 s on the page so a stray move on arrival does not fire it. */
    var fine = window.matchMedia && window.matchMedia('(pointer:fine)');
    if (fine && fine.matches) {
      document.addEventListener('mouseleave', function onLeave(e) {
        if (e.clientY > 0) return;
        if (Date.now() - loadedAt < EXIT_MIN_MS) return;
        document.removeEventListener('mouseleave', onLeave);
        trigger('exit');
      });
    }
  }

  pop.addEventListener('click', function (e) {
    if (e.target.hasAttribute('data-rm-pop-close')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !pop.hidden) close();
  });

  /* Keep tabbing inside the dialog while it is open. */
  pop.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || pop.hidden) return;
    var f = pop.querySelectorAll('button, input, a[href]');
    var list = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  function showSuccess() {
    pop.querySelector('[data-rm-pop-view="offer"]').hidden = true;
    pop.querySelector('[data-rm-pop-view="success"]').hidden = false;
    remember_();
    var c = pop.querySelector('#rm-pop-copy');
    if (c) c.focus();
  }

  /* Shopify's customer form posts and reloads with ?customer_posted=true.
     Re-open straight onto the success view so the code is not lost. */
  var form = document.getElementById('rm-pop-form');
  if (form) {
    form.addEventListener('submit', function () {
      try { sessionStorage.setItem(REGION_KEY, region); } catch (e) {}
      track('popup_submit', {});
    });
  }

  if (/[?&]customer_posted=true/.test(window.location.search)) {
    var posted = null;
    try { posted = sessionStorage.getItem(REGION_KEY); sessionStorage.removeItem(REGION_KEY); } catch (e) {}
    /* Any customer form post shows the success view, as before; a post from
       this popup also keeps the offer it showed. */
    if (posted === 'intl') useIntl();
    open(true, 'return');
    showSuccess();
  }

  var copy = document.getElementById('rm-pop-copy');
  if (copy) {
    copy.addEventListener('click', function () {
      track('popup_copy', {});
      var code = (document.getElementById('rm-pop-code') || {}).textContent || '';
      var done = function () {
        copy.textContent = 'Copied';
        setTimeout(function () { copy.textContent = copy.dataset.label; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code.trim()).then(done).catch(done);
      } else {
        done();
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
(function () {
  var grid = document.getElementById('rm-search-grid');
  if (!grid) return;

  var q = (grid.dataset.query || '').trim();
  if (!q) return;

  var countEl = document.getElementById('rm-search-count');

  // Search events (snippets/rm-search-events): one `search` for the answer the
  // buyer finally sees, then clicks on it. engine=shared when the shared matcher
  // took over the grid, shopify when Shopify's own results were kept.
  // engine=loose means nothing matched and closest matches were shown: it is
  // still logged as 0 results, so zero-result reporting stays honest, with
  // loose = how many closest matches the buyer saw.
  var logged = false, looseShown = 0;
  function logSearch(engine) {
    if (logged || !window.RMSearchEvents) return;
    logged = true;
    var n = looseShown ? 0 : grid.querySelectorAll('.rm-card').length;
    var extra = { engine: engine, server: grid.dataset.serverCount || 0 };
    if (looseShown) extra.loose = looseShown;
    window.RMSearchEvents.searched('search_page', q, n, extra);
  }
  // The index can fail or be slow. Shopify's answer is on the page either way,
  // so it is logged after a few seconds rather than never.
  setTimeout(function () { logSearch('shopify'); }, 4000);

  grid.addEventListener('click', function (e) {
    var a = e.target.closest('a, button');
    var cardEl = a && a.closest('.rm-card');
    if (!cardEl || !window.RMSearchEvents) return;
    logSearch('shopify');
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.rm-card'));
    window.RMSearchEvents.click('search_page', q, cardEl.getAttribute('data-product-id'),
      cards.indexOf(cardEl) + 1, cards.length, looseShown
        ? { via: a.tagName === 'BUTTON' ? 'add' : 'open', loose: 1 }
        : { via: a.tagName === 'BUTTON' ? 'add' : 'open' });
  });

  // The theme's per-section JS blocks are concatenated into ONE bundle in no
  // guaranteed order, so window.RMSearch may not exist yet when this runs.
  // Bailing on a bare truthiness check made the takeover silently never happen.
  function whenReady(fn) {
    if (window.RMSearch) { fn(); return; }
    var tries = 0;
    var t = setInterval(function () {
      if (window.RMSearch) { clearInterval(t); fn(); }
      else if (++tries > 40) clearInterval(t);
    }, 50);
  }

  whenReady(function () {
  window.RMSearch.ready(function () {
    var matches = window.RMSearch.find(q);
    // Nothing matched anywhere: offer the closest matches (forgiving search,
    // only when switched on), clearly labelled as not an exact match.
    if (!matches.length && grid.querySelectorAll('.rm-card').length === 0
        && window.RMSearch.findLoose && window.RMSearch.looseOn()) {
      var close = window.RMSearch.findLoose(q, { limit: 12 });
      if (close.length) {
        looseShown = close.length;
        var safeQ = q.replace(/&/g, '&amp;').replace(/</g, '&lt;');
        grid.innerHTML = '<div class="rm-col__empty rm-search__loose">'
          + '<p class="rm-col__empty-title">No exact match for &ldquo;' + safeQ + '&rdquo;</p>'
          + '<p class="rm-col__empty-body">These are the closest mounts we make. Check the model before you order, or ask us to design one.</p>'
          + '</div>' + close.map(window.RMSearch.card).join('');
        if (countEl) countEl.textContent = 'Closest matches';
        logSearch('loose');
        return;
      }
    }
    // keep Shopify's own answer rather than blanking the page
    if (!matches.length) { logSearch('shopify'); return; }

    var serverCount = grid.querySelectorAll('.rm-card').length;

    // Only take over when the shared matcher genuinely does better. Replacing
    // an equal or better server result would just cause a visible reshuffle
    // for no gain.
    if (matches.length <= serverCount) { logSearch('shopify'); return; }

    grid.innerHTML = matches.map(window.RMSearch.card).join('');
    if (countEl) {
      countEl.textContent = matches.length + ' result' + (matches.length === 1 ? '' : 's');
    }
    logSearch('shared');
  });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
